var items = {
  "block.minecraft.acacia_button": "相思木按鈕",
  "block.minecraft.acacia_door": "相思木門",
  "block.minecraft.acacia_fence": "相思木柵欄",
  "block.minecraft.acacia_fence_gate": "相思木柵欄門",
  "block.minecraft.acacia_hanging_sign": "懸掛式相思木告示牌",
  "block.minecraft.acacia_leaves": "相思木樹葉",
  "block.minecraft.acacia_log": "相思木原木",
  "block.minecraft.acacia_planks": "相思木材",
  "block.minecraft.acacia_pressure_plate": "相思木壓力板",
  "block.minecraft.acacia_sapling": "相思木樹苗",
  "block.minecraft.acacia_shelf": "相思木展示架",
  "block.minecraft.acacia_sign": "相思木告示牌",
  "block.minecraft.acacia_slab": "相思木半磚",
  "block.minecraft.acacia_stairs": "相思木階梯",
  "block.minecraft.acacia_trapdoor": "相思木地板門",
  "block.minecraft.acacia_wall_hanging_sign": "牆上的懸掛式相思木告示牌",
  "block.minecraft.acacia_wall_sign": "牆上的相思木告示牌",
  "block.minecraft.acacia_wood": "相思木塊",
  "block.minecraft.activator_rail": "觸發鐵軌",
  "block.minecraft.air": "空氣",
  "block.minecraft.allium": "紫紅球花",
  "block.minecraft.amethyst_block": "紫水晶方塊",
  "block.minecraft.amethyst_cluster": "紫水晶晶簇",
  "block.minecraft.ancient_debris": "遠古遺骸",
  "block.minecraft.andesite": "安山岩",
  "block.minecraft.andesite_slab": "安山岩半磚",
  "block.minecraft.andesite_stairs": "安山岩階梯",
  "block.minecraft.andesite_wall": "安山岩牆",
  "block.minecraft.anvil": "鐵砧",
  "block.minecraft.attached_melon_stem": "連接的西瓜梗",
  "block.minecraft.attached_pumpkin_stem": "連接的南瓜梗",
  "block.minecraft.azalea": "杜鵑叢",
  "block.minecraft.azalea_leaves": "杜鵑葉",
  "block.minecraft.azure_bluet": "雛草",
  "block.minecraft.bamboo": "竹子",
  "block.minecraft.bamboo_block": "竹方塊",
  "block.minecraft.bamboo_button": "竹按鈕",
  "block.minecraft.bamboo_door": "竹門",
  "block.minecraft.bamboo_fence": "竹柵欄",
  "block.minecraft.bamboo_fence_gate": "竹柵欄門",
  "block.minecraft.bamboo_hanging_sign": "懸掛式竹告示牌",
  "block.minecraft.bamboo_mosaic": "竹拼塊",
  "block.minecraft.bamboo_mosaic_slab": "竹拼半磚",
  "block.minecraft.bamboo_mosaic_stairs": "竹拼階梯",
  "block.minecraft.bamboo_planks": "竹材",
  "block.minecraft.bamboo_pressure_plate": "竹壓力板",
  "block.minecraft.bamboo_sapling": "竹筍",
  "block.minecraft.bamboo_shelf": "竹展示架",
  "block.minecraft.bamboo_sign": "竹告示牌",
  "block.minecraft.bamboo_slab": "竹半磚",
  "block.minecraft.bamboo_stairs": "竹階梯",
  "block.minecraft.bamboo_trapdoor": "竹地板門",
  "block.minecraft.bamboo_wall_hanging_sign": "牆上的懸掛式竹告示牌",
  "block.minecraft.bamboo_wall_sign": "牆上的竹告示牌",
  "block.minecraft.banner.base.black": "黑色基底",
  "block.minecraft.banner.base.blue": "藍色基底",
  "block.minecraft.banner.base.brown": "棕色基底",
  "block.minecraft.banner.base.cyan": "青色基底",
  "block.minecraft.banner.base.gray": "灰色基底",
  "block.minecraft.banner.base.green": "綠色基底",
  "block.minecraft.banner.base.light_blue": "淺藍色基底",
  "block.minecraft.banner.base.light_gray": "淺灰色基底",
  "block.minecraft.banner.base.lime": "淺綠色基底",
  "block.minecraft.banner.base.magenta": "洋紅色基底",
  "block.minecraft.banner.base.orange": "橙色基底",
  "block.minecraft.banner.base.pink": "粉紅色基底",
  "block.minecraft.banner.base.purple": "紫色基底",
  "block.minecraft.banner.base.red": "紅色基底",
  "block.minecraft.banner.base.white": "白色基底",
  "block.minecraft.banner.base.yellow": "黃色基底",
  "block.minecraft.banner.border.black": "黑色框邊",
  "block.minecraft.banner.border.blue": "藍色框邊",
  "block.minecraft.banner.border.brown": "棕色框邊",
  "block.minecraft.banner.border.cyan": "青色框邊",
  "block.minecraft.banner.border.gray": "灰色框邊",
  "block.minecraft.banner.border.green": "綠色框邊",
  "block.minecraft.banner.border.light_blue": "淺藍色框邊",
  "block.minecraft.banner.border.light_gray": "淺灰色框邊",
  "block.minecraft.banner.border.lime": "淺綠色框邊",
  "block.minecraft.banner.border.magenta": "洋紅色框邊",
  "block.minecraft.banner.border.orange": "橙色框邊",
  "block.minecraft.banner.border.pink": "粉紅色框邊",
  "block.minecraft.banner.border.purple": "紫色框邊",
  "block.minecraft.banner.border.red": "紅色框邊",
  "block.minecraft.banner.border.white": "白色框邊",
  "block.minecraft.banner.border.yellow": "黃色框邊",
  "block.minecraft.banner.bricks.black": "黑色磚牆花紋",
  "block.minecraft.banner.bricks.blue": "藍色磚牆花紋",
  "block.minecraft.banner.bricks.brown": "棕色磚牆花紋",
  "block.minecraft.banner.bricks.cyan": "青色磚牆花紋",
  "block.minecraft.banner.bricks.gray": "灰色磚牆花紋",
  "block.minecraft.banner.bricks.green": "綠色磚牆花紋",
  "block.minecraft.banner.bricks.light_blue": "淺藍色磚牆花紋",
  "block.minecraft.banner.bricks.light_gray": "淺灰色磚牆花紋",
  "block.minecraft.banner.bricks.lime": "淺綠色磚牆花紋",
  "block.minecraft.banner.bricks.magenta": "洋紅色磚牆花紋",
  "block.minecraft.banner.bricks.orange": "橙色磚牆花紋",
  "block.minecraft.banner.bricks.pink": "粉紅色磚牆花紋",
  "block.minecraft.banner.bricks.purple": "紫色磚牆花紋",
  "block.minecraft.banner.bricks.red": "紅色磚牆花紋",
  "block.minecraft.banner.bricks.white": "白色磚牆花紋",
  "block.minecraft.banner.bricks.yellow": "黃色磚牆花紋",
  "block.minecraft.banner.circle.black": "黑色圓形",
  "block.minecraft.banner.circle.blue": "藍色圓形",
  "block.minecraft.banner.circle.brown": "棕色圓形",
  "block.minecraft.banner.circle.cyan": "青色圓形",
  "block.minecraft.banner.circle.gray": "灰色圓形",
  "block.minecraft.banner.circle.green": "綠色圓形",
  "block.minecraft.banner.circle.light_blue": "淺藍色圓形",
  "block.minecraft.banner.circle.light_gray": "淺灰色圓形",
  "block.minecraft.banner.circle.lime": "淺綠色圓形",
  "block.minecraft.banner.circle.magenta": "洋紅色圓形",
  "block.minecraft.banner.circle.orange": "橙色圓形",
  "block.minecraft.banner.circle.pink": "粉紅色圓形",
  "block.minecraft.banner.circle.purple": "紫色圓形",
  "block.minecraft.banner.circle.red": "紅色圓形",
  "block.minecraft.banner.circle.white": "白色圓形",
  "block.minecraft.banner.circle.yellow": "黃色圓形",
  "block.minecraft.banner.creeper.black": "黑色苦力怕圖紋",
  "block.minecraft.banner.creeper.blue": "藍色苦力怕圖紋",
  "block.minecraft.banner.creeper.brown": "棕色苦力怕圖紋",
  "block.minecraft.banner.creeper.cyan": "青色苦力怕圖紋",
  "block.minecraft.banner.creeper.gray": "灰色苦力怕圖紋",
  "block.minecraft.banner.creeper.green": "綠色苦力怕圖紋",
  "block.minecraft.banner.creeper.light_blue": "淺藍色苦力怕圖紋",
  "block.minecraft.banner.creeper.light_gray": "淺灰色苦力怕圖紋",
  "block.minecraft.banner.creeper.lime": "淺綠色苦力怕圖紋",
  "block.minecraft.banner.creeper.magenta": "洋紅色苦力怕圖紋",
  "block.minecraft.banner.creeper.orange": "橙色苦力怕圖紋",
  "block.minecraft.banner.creeper.pink": "粉紅色苦力怕圖紋",
  "block.minecraft.banner.creeper.purple": "紫色苦力怕圖紋",
  "block.minecraft.banner.creeper.red": "紅色苦力怕圖紋",
  "block.minecraft.banner.creeper.white": "白色苦力怕圖紋",
  "block.minecraft.banner.creeper.yellow": "黃色苦力怕圖紋",
  "block.minecraft.banner.cross.black": "黑色對角交叉",
  "block.minecraft.banner.cross.blue": "藍色對角交叉",
  "block.minecraft.banner.cross.brown": "棕色對角交叉",
  "block.minecraft.banner.cross.cyan": "青色對角交叉",
  "block.minecraft.banner.cross.gray": "灰色對角交叉",
  "block.minecraft.banner.cross.green": "綠色對角交叉",
  "block.minecraft.banner.cross.light_blue": "淺藍色對角交叉",
  "block.minecraft.banner.cross.light_gray": "淺灰色對角交叉",
  "block.minecraft.banner.cross.lime": "淺綠色對角交叉",
  "block.minecraft.banner.cross.magenta": "洋紅色對角交叉",
  "block.minecraft.banner.cross.orange": "橙色對角交叉",
  "block.minecraft.banner.cross.pink": "粉紅色對角交叉",
  "block.minecraft.banner.cross.purple": "紫色對角交叉",
  "block.minecraft.banner.cross.red": "紅色對角交叉",
  "block.minecraft.banner.cross.white": "白色對角交叉",
  "block.minecraft.banner.cross.yellow": "黃色對角交叉",
  "block.minecraft.banner.curly_border.black": "黑色鋸齒框邊",
  "block.minecraft.banner.curly_border.blue": "藍色鋸齒框邊",
  "block.minecraft.banner.curly_border.brown": "棕色鋸齒框邊",
  "block.minecraft.banner.curly_border.cyan": "青色鋸齒框邊",
  "block.minecraft.banner.curly_border.gray": "灰色鋸齒框邊",
  "block.minecraft.banner.curly_border.green": "綠色鋸齒框邊",
  "block.minecraft.banner.curly_border.light_blue": "淺藍色鋸齒框邊",
  "block.minecraft.banner.curly_border.light_gray": "淺灰色鋸齒框邊",
  "block.minecraft.banner.curly_border.lime": "淺綠色鋸齒框邊",
  "block.minecraft.banner.curly_border.magenta": "洋紅色鋸齒框邊",
  "block.minecraft.banner.curly_border.orange": "橙色鋸齒框邊",
  "block.minecraft.banner.curly_border.pink": "粉紅色鋸齒框邊",
  "block.minecraft.banner.curly_border.purple": "紫色鋸齒框邊",
  "block.minecraft.banner.curly_border.red": "紅色鋸齒框邊",
  "block.minecraft.banner.curly_border.white": "白色鋸齒框邊",
  "block.minecraft.banner.curly_border.yellow": "黃色鋸齒框邊",
  "block.minecraft.banner.diagonal_left.black": "左上方黑色填滿",
  "block.minecraft.banner.diagonal_left.blue": "左上方藍色填滿",
  "block.minecraft.banner.diagonal_left.brown": "左上方棕色填滿",
  "block.minecraft.banner.diagonal_left.cyan": "左上方青色填滿",
  "block.minecraft.banner.diagonal_left.gray": "左上方灰色填滿",
  "block.minecraft.banner.diagonal_left.green": "左上方綠色填滿",
  "block.minecraft.banner.diagonal_left.light_blue": "左上方淺藍色填滿",
  "block.minecraft.banner.diagonal_left.light_gray": "左上方淺灰色填滿",
  "block.minecraft.banner.diagonal_left.lime": "左上方淺綠色填滿",
  "block.minecraft.banner.diagonal_left.magenta": "左上方洋紅色填滿",
  "block.minecraft.banner.diagonal_left.orange": "左上方橙色填滿",
  "block.minecraft.banner.diagonal_left.pink": "左上方粉紅色填滿",
  "block.minecraft.banner.diagonal_left.purple": "左上方紫色填滿",
  "block.minecraft.banner.diagonal_left.red": "左上方紅色填滿",
  "block.minecraft.banner.diagonal_left.white": "左上方白色填滿",
  "block.minecraft.banner.diagonal_left.yellow": "左上方黃色填滿",
  "block.minecraft.banner.diagonal_right.black": "右上方黑色填滿",
  "block.minecraft.banner.diagonal_right.blue": "右上方藍色填滿",
  "block.minecraft.banner.diagonal_right.brown": "右上方棕色填滿",
  "block.minecraft.banner.diagonal_right.cyan": "右上方青色填滿",
  "block.minecraft.banner.diagonal_right.gray": "右上方灰色填滿",
  "block.minecraft.banner.diagonal_right.green": "右上方綠色填滿",
  "block.minecraft.banner.diagonal_right.light_blue": "右上方淺藍色填滿",
  "block.minecraft.banner.diagonal_right.light_gray": "右上方淺灰色填滿",
  "block.minecraft.banner.diagonal_right.lime": "右上方淺綠色填滿",
  "block.minecraft.banner.diagonal_right.magenta": "右上方洋紅色填滿",
  "block.minecraft.banner.diagonal_right.orange": "右上方橙色填滿",
  "block.minecraft.banner.diagonal_right.pink": "右上方粉紅色填滿",
  "block.minecraft.banner.diagonal_right.purple": "右上方紫色填滿",
  "block.minecraft.banner.diagonal_right.red": "右上方紅色填滿",
  "block.minecraft.banner.diagonal_right.white": "右上方白色填滿",
  "block.minecraft.banner.diagonal_right.yellow": "右上方黃色填滿",
  "block.minecraft.banner.diagonal_up_left.black": "左下方黑色填滿",
  "block.minecraft.banner.diagonal_up_left.blue": "左下方藍色填滿",
  "block.minecraft.banner.diagonal_up_left.brown": "左下方棕色填滿",
  "block.minecraft.banner.diagonal_up_left.cyan": "左下方青色填滿",
  "block.minecraft.banner.diagonal_up_left.gray": "左下方灰色填滿",
  "block.minecraft.banner.diagonal_up_left.green": "左下方綠色填滿",
  "block.minecraft.banner.diagonal_up_left.light_blue": "左下方淺藍色填滿",
  "block.minecraft.banner.diagonal_up_left.light_gray": "左下方淺灰色填滿",
  "block.minecraft.banner.diagonal_up_left.lime": "左下方淺綠色填滿",
  "block.minecraft.banner.diagonal_up_left.magenta": "左下方洋紅色填滿",
  "block.minecraft.banner.diagonal_up_left.orange": "左下方橙色填滿",
  "block.minecraft.banner.diagonal_up_left.pink": "左下方粉紅色填滿",
  "block.minecraft.banner.diagonal_up_left.purple": "左下方紫色填滿",
  "block.minecraft.banner.diagonal_up_left.red": "左下方紅色填滿",
  "block.minecraft.banner.diagonal_up_left.white": "左下方白色填滿",
  "block.minecraft.banner.diagonal_up_left.yellow": "左下方黃色填滿",
  "block.minecraft.banner.diagonal_up_right.black": "右下方黑色填滿",
  "block.minecraft.banner.diagonal_up_right.blue": "右下方藍色填滿",
  "block.minecraft.banner.diagonal_up_right.brown": "右下方棕色填滿",
  "block.minecraft.banner.diagonal_up_right.cyan": "右下方青色填滿",
  "block.minecraft.banner.diagonal_up_right.gray": "右下半部分灰色填滿",
  "block.minecraft.banner.diagonal_up_right.green": "右下方綠色填滿",
  "block.minecraft.banner.diagonal_up_right.light_blue": "右下半部分淺藍色填滿",
  "block.minecraft.banner.diagonal_up_right.light_gray": "右下方淺灰色填滿",
  "block.minecraft.banner.diagonal_up_right.lime": "右下半部分淺綠色填滿",
  "block.minecraft.banner.diagonal_up_right.magenta": "右下方洋紅色填滿",
  "block.minecraft.banner.diagonal_up_right.orange": "右下方橙色填滿",
  "block.minecraft.banner.diagonal_up_right.pink": "右下方粉紅色填滿",
  "block.minecraft.banner.diagonal_up_right.purple": "右下方紫色填滿",
  "block.minecraft.banner.diagonal_up_right.red": "右下方紅色填滿",
  "block.minecraft.banner.diagonal_up_right.white": "右下方白色填滿",
  "block.minecraft.banner.diagonal_up_right.yellow": "右下方黃色填滿",
  "block.minecraft.banner.flow.black": "黑色渦流",
  "block.minecraft.banner.flow.blue": "藍色渦流",
  "block.minecraft.banner.flow.brown": "棕色渦流",
  "block.minecraft.banner.flow.cyan": "青色渦流",
  "block.minecraft.banner.flow.gray": "灰色渦流",
  "block.minecraft.banner.flow.green": "綠色渦流",
  "block.minecraft.banner.flow.light_blue": "淺藍色渦流",
  "block.minecraft.banner.flow.light_gray": "淺灰色渦流",
  "block.minecraft.banner.flow.lime": "淺綠色渦流",
  "block.minecraft.banner.flow.magenta": "洋紅色渦流",
  "block.minecraft.banner.flow.orange": "橙色渦流",
  "block.minecraft.banner.flow.pink": "粉紅色渦流",
  "block.minecraft.banner.flow.purple": "紫色渦流",
  "block.minecraft.banner.flow.red": "紅色渦流",
  "block.minecraft.banner.flow.white": "白色渦流",
  "block.minecraft.banner.flow.yellow": "黃色渦流",
  "block.minecraft.banner.flower.black": "黑色花朵圖紋",
  "block.minecraft.banner.flower.blue": "藍色花朵圖紋",
  "block.minecraft.banner.flower.brown": "棕色花朵圖紋",
  "block.minecraft.banner.flower.cyan": "青色花朵圖紋",
  "block.minecraft.banner.flower.gray": "灰色花朵圖紋",
  "block.minecraft.banner.flower.green": "綠色花朵圖紋",
  "block.minecraft.banner.flower.light_blue": "淺藍色花朵圖紋",
  "block.minecraft.banner.flower.light_gray": "淺灰色花朵圖紋",
  "block.minecraft.banner.flower.lime": "淺綠色花朵圖紋",
  "block.minecraft.banner.flower.magenta": "洋紅色花朵圖紋",
  "block.minecraft.banner.flower.orange": "橙色花朵圖紋",
  "block.minecraft.banner.flower.pink": "粉紅色花朵圖紋",
  "block.minecraft.banner.flower.purple": "紫色花朵圖紋",
  "block.minecraft.banner.flower.red": "紅色花朵圖紋",
  "block.minecraft.banner.flower.white": "白色花朵圖紋",
  "block.minecraft.banner.flower.yellow": "黃色花朵圖紋",
  "block.minecraft.banner.globe.black": "黑色地球",
  "block.minecraft.banner.globe.blue": "藍色地球",
  "block.minecraft.banner.globe.brown": "棕色地球",
  "block.minecraft.banner.globe.cyan": "青色地球",
  "block.minecraft.banner.globe.gray": "灰色地球",
  "block.minecraft.banner.globe.green": "綠色地球",
  "block.minecraft.banner.globe.light_blue": "淺藍色地球",
  "block.minecraft.banner.globe.light_gray": "淺灰色地球",
  "block.minecraft.banner.globe.lime": "淺綠色地球",
  "block.minecraft.banner.globe.magenta": "洋紅色地球",
  "block.minecraft.banner.globe.orange": "橙色地球",
  "block.minecraft.banner.globe.pink": "粉紅色地球",
  "block.minecraft.banner.globe.purple": "紫色地球",
  "block.minecraft.banner.globe.red": "紅色地球",
  "block.minecraft.banner.globe.white": "白色地球",
  "block.minecraft.banner.globe.yellow": "黃色地球",
  "block.minecraft.banner.gradient.black": "黑色往下漸淡",
  "block.minecraft.banner.gradient.blue": "藍色往下漸淡",
  "block.minecraft.banner.gradient.brown": "棕色往下漸淡",
  "block.minecraft.banner.gradient.cyan": "青色往下漸淡",
  "block.minecraft.banner.gradient.gray": "灰色往下漸淡",
  "block.minecraft.banner.gradient.green": "綠色往下漸淡",
  "block.minecraft.banner.gradient.light_blue": "淺藍色往下漸淡",
  "block.minecraft.banner.gradient.light_gray": "淺灰色往下漸淡",
  "block.minecraft.banner.gradient.lime": "淺綠色往下漸淡",
  "block.minecraft.banner.gradient.magenta": "洋紅色往下漸淡",
  "block.minecraft.banner.gradient.orange": "橙色往下漸淡",
  "block.minecraft.banner.gradient.pink": "粉紅色往下漸淡",
  "block.minecraft.banner.gradient.purple": "紫色往下漸淡",
  "block.minecraft.banner.gradient.red": "紅色往下漸淡",
  "block.minecraft.banner.gradient.white": "白色往下漸淡",
  "block.minecraft.banner.gradient.yellow": "黃色往下漸淡",
  "block.minecraft.banner.gradient_up.black": "黑色往上漸淡",
  "block.minecraft.banner.gradient_up.blue": "藍色往上漸淡",
  "block.minecraft.banner.gradient_up.brown": "棕色往上漸淡",
  "block.minecraft.banner.gradient_up.cyan": "青色往上漸淡",
  "block.minecraft.banner.gradient_up.gray": "灰色往上漸淡",
  "block.minecraft.banner.gradient_up.green": "綠色往上漸淡",
  "block.minecraft.banner.gradient_up.light_blue": "淺藍色往上漸淡",
  "block.minecraft.banner.gradient_up.light_gray": "淺灰色往上漸淡",
  "block.minecraft.banner.gradient_up.lime": "淺綠色往上漸淡",
  "block.minecraft.banner.gradient_up.magenta": "洋紅色往上漸淡",
  "block.minecraft.banner.gradient_up.orange": "橙色往上漸淡",
  "block.minecraft.banner.gradient_up.pink": "粉紅色往上漸淡",
  "block.minecraft.banner.gradient_up.purple": "紫色往上漸淡",
  "block.minecraft.banner.gradient_up.red": "紅色往上漸淡",
  "block.minecraft.banner.gradient_up.white": "白色往上漸淡",
  "block.minecraft.banner.gradient_up.yellow": "黃色往上漸淡",
  "block.minecraft.banner.guster.black": "黑色狂風",
  "block.minecraft.banner.guster.blue": "藍色狂風",
  "block.minecraft.banner.guster.brown": "棕色狂風",
  "block.minecraft.banner.guster.cyan": "青色狂風",
  "block.minecraft.banner.guster.gray": "灰色狂風",
  "block.minecraft.banner.guster.green": "綠色狂風",
  "block.minecraft.banner.guster.light_blue": "淺藍色狂風",
  "block.minecraft.banner.guster.light_gray": "淺灰色狂風",
  "block.minecraft.banner.guster.lime": "淺綠色狂風",
  "block.minecraft.banner.guster.magenta": "洋紅色狂風",
  "block.minecraft.banner.guster.orange": "橙色狂風",
  "block.minecraft.banner.guster.pink": "粉紅色狂風",
  "block.minecraft.banner.guster.purple": "紫色狂風",
  "block.minecraft.banner.guster.red": "紅色狂風",
  "block.minecraft.banner.guster.white": "白色狂風",
  "block.minecraft.banner.guster.yellow": "黃色狂風",
  "block.minecraft.banner.half_horizontal.black": "上半部分黑色填滿",
  "block.minecraft.banner.half_horizontal.blue": "上半部分藍色填滿",
  "block.minecraft.banner.half_horizontal.brown": "上半部分棕色填滿",
  "block.minecraft.banner.half_horizontal.cyan": "上半部分青色填滿",
  "block.minecraft.banner.half_horizontal.gray": "上半部分灰色填滿",
  "block.minecraft.banner.half_horizontal.green": "上半部分綠色填滿",
  "block.minecraft.banner.half_horizontal.light_blue": "上半部分淺藍色填滿",
  "block.minecraft.banner.half_horizontal.light_gray": "上半部分淺灰色填滿",
  "block.minecraft.banner.half_horizontal.lime": "上半部分淺綠色填滿",
  "block.minecraft.banner.half_horizontal.magenta": "上半部分洋紅色填滿",
  "block.minecraft.banner.half_horizontal.orange": "上半部分橙色填滿",
  "block.minecraft.banner.half_horizontal.pink": "上半部分粉紅色填滿",
  "block.minecraft.banner.half_horizontal.purple": "上半部分紫色填滿",
  "block.minecraft.banner.half_horizontal.red": "上半部分紅色填滿",
  "block.minecraft.banner.half_horizontal.white": "上半部分白色填滿",
  "block.minecraft.banner.half_horizontal.yellow": "上半部分黃色填滿",
  "block.minecraft.banner.half_horizontal_bottom.black": "下半部分黑色填滿",
  "block.minecraft.banner.half_horizontal_bottom.blue": "下半部分藍色填滿",
  "block.minecraft.banner.half_horizontal_bottom.brown": "下半部分棕色填滿",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "下半部分青色填滿",
  "block.minecraft.banner.half_horizontal_bottom.gray": "下半部分灰色填滿",
  "block.minecraft.banner.half_horizontal_bottom.green": "下半部分綠色填滿",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "下半部分淺藍色填滿",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "下半部分淺灰色填滿",
  "block.minecraft.banner.half_horizontal_bottom.lime": "下半部分淺綠色填滿",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "下半部分洋紅色填滿",
  "block.minecraft.banner.half_horizontal_bottom.orange": "下半部分橙色填滿",
  "block.minecraft.banner.half_horizontal_bottom.pink": "下半部分粉紅色填滿",
  "block.minecraft.banner.half_horizontal_bottom.purple": "下半部分紫色填滿",
  "block.minecraft.banner.half_horizontal_bottom.red": "下半部分紅色填滿",
  "block.minecraft.banner.half_horizontal_bottom.white": "下半部分白色填滿",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "下半部分黃色填滿",
  "block.minecraft.banner.half_vertical.black": "左半部分黑色填滿",
  "block.minecraft.banner.half_vertical.blue": "左半部分藍色填滿",
  "block.minecraft.banner.half_vertical.brown": "左半部分棕色填滿",
  "block.minecraft.banner.half_vertical.cyan": "左半部分青色填滿",
  "block.minecraft.banner.half_vertical.gray": "左半部分灰色填滿",
  "block.minecraft.banner.half_vertical.green": "左半部分綠色填滿",
  "block.minecraft.banner.half_vertical.light_blue": "左半部分淺藍色填滿",
  "block.minecraft.banner.half_vertical.light_gray": "左半部分淺灰色填滿",
  "block.minecraft.banner.half_vertical.lime": "左半部分淺綠色填滿",
  "block.minecraft.banner.half_vertical.magenta": "左半部分洋紅色填滿",
  "block.minecraft.banner.half_vertical.orange": "左半部分橙色填滿",
  "block.minecraft.banner.half_vertical.pink": "左半部分粉紅色填滿",
  "block.minecraft.banner.half_vertical.purple": "左半部分紫色填滿",
  "block.minecraft.banner.half_vertical.red": "左半部分紅色填滿",
  "block.minecraft.banner.half_vertical.white": "左半部分白色填滿",
  "block.minecraft.banner.half_vertical.yellow": "左半部分黃色填滿",
  "block.minecraft.banner.half_vertical_right.black": "右半部分黑色填滿",
  "block.minecraft.banner.half_vertical_right.blue": "右半部分藍色填滿",
  "block.minecraft.banner.half_vertical_right.brown": "右半部分棕色填滿",
  "block.minecraft.banner.half_vertical_right.cyan": "右半部分青色填滿",
  "block.minecraft.banner.half_vertical_right.gray": "右半部分灰色填滿",
  "block.minecraft.banner.half_vertical_right.green": "右半部分綠色填滿",
  "block.minecraft.banner.half_vertical_right.light_blue": "右半部分淺藍色填滿",
  "block.minecraft.banner.half_vertical_right.light_gray": "右半部分淺灰色填滿",
  "block.minecraft.banner.half_vertical_right.lime": "右半部分淺綠色填滿",
  "block.minecraft.banner.half_vertical_right.magenta": "右半部分洋紅色填滿",
  "block.minecraft.banner.half_vertical_right.orange": "右半部分橙色填滿",
  "block.minecraft.banner.half_vertical_right.pink": "右半部分粉紅色填滿",
  "block.minecraft.banner.half_vertical_right.purple": "右半部分紫色填滿",
  "block.minecraft.banner.half_vertical_right.red": "右半部分紅色填滿",
  "block.minecraft.banner.half_vertical_right.white": "右半部分白色填滿",
  "block.minecraft.banner.half_vertical_right.yellow": "右半部分黃色填滿",
  "block.minecraft.banner.mojang.black": "黑色 Mojang 標誌",
  "block.minecraft.banner.mojang.blue": "藍色 Mojang 標誌",
  "block.minecraft.banner.mojang.brown": "棕色 Mojang 標誌",
  "block.minecraft.banner.mojang.cyan": "青色 Mojang 標誌",
  "block.minecraft.banner.mojang.gray": "灰色 Mojang 標誌",
  "block.minecraft.banner.mojang.green": "綠色 Mojang 標誌",
  "block.minecraft.banner.mojang.light_blue": "淺藍色 Mojang 標誌",
  "block.minecraft.banner.mojang.light_gray": "淺灰色 Mojang 標誌",
  "block.minecraft.banner.mojang.lime": "淺綠色 Mojang 標誌",
  "block.minecraft.banner.mojang.magenta": "洋紅色 Mojang 標誌",
  "block.minecraft.banner.mojang.orange": "橙色 Mojang 標誌",
  "block.minecraft.banner.mojang.pink": "粉紅色 Mojang 標誌",
  "block.minecraft.banner.mojang.purple": "紫色 Mojang 標誌",
  "block.minecraft.banner.mojang.red": "紅色 Mojang 標誌",
  "block.minecraft.banner.mojang.white": "白色 Mojang 標誌",
  "block.minecraft.banner.mojang.yellow": "黃色 Mojang 標誌",
  "block.minecraft.banner.piglin.black": "黑色豬鼻",
  "block.minecraft.banner.piglin.blue": "藍色豬鼻",
  "block.minecraft.banner.piglin.brown": "棕色豬鼻",
  "block.minecraft.banner.piglin.cyan": "青色豬鼻",
  "block.minecraft.banner.piglin.gray": "灰色豬鼻",
  "block.minecraft.banner.piglin.green": "綠色豬鼻",
  "block.minecraft.banner.piglin.light_blue": "淺藍色豬鼻",
  "block.minecraft.banner.piglin.light_gray": "淺灰色豬鼻",
  "block.minecraft.banner.piglin.lime": "淺綠色豬鼻",
  "block.minecraft.banner.piglin.magenta": "洋紅色豬鼻",
  "block.minecraft.banner.piglin.orange": "橙色豬鼻",
  "block.minecraft.banner.piglin.pink": "粉紅色豬鼻",
  "block.minecraft.banner.piglin.purple": "紫色豬鼻",
  "block.minecraft.banner.piglin.red": "紅色豬鼻",
  "block.minecraft.banner.piglin.white": "白色豬鼻",
  "block.minecraft.banner.piglin.yellow": "黃色豬鼻",
  "block.minecraft.banner.rhombus.black": "黑色菱形",
  "block.minecraft.banner.rhombus.blue": "藍色菱形",
  "block.minecraft.banner.rhombus.brown": "棕色菱形",
  "block.minecraft.banner.rhombus.cyan": "青色菱形",
  "block.minecraft.banner.rhombus.gray": "灰色菱形",
  "block.minecraft.banner.rhombus.green": "綠色菱形",
  "block.minecraft.banner.rhombus.light_blue": "淺藍色菱形",
  "block.minecraft.banner.rhombus.light_gray": "淺灰色菱形",
  "block.minecraft.banner.rhombus.lime": "淺綠色菱形",
  "block.minecraft.banner.rhombus.magenta": "洋紅色菱形",
  "block.minecraft.banner.rhombus.orange": "橙色菱形",
  "block.minecraft.banner.rhombus.pink": "粉紅色菱形",
  "block.minecraft.banner.rhombus.purple": "紫色菱形",
  "block.minecraft.banner.rhombus.red": "紅色菱形",
  "block.minecraft.banner.rhombus.white": "白色菱形",
  "block.minecraft.banner.rhombus.yellow": "黃色菱形",
  "block.minecraft.banner.skull.black": "黑色骷髏圖紋",
  "block.minecraft.banner.skull.blue": "藍色骷髏圖紋",
  "block.minecraft.banner.skull.brown": "棕色骷髏圖紋",
  "block.minecraft.banner.skull.cyan": "青色骷髏圖紋",
  "block.minecraft.banner.skull.gray": "灰色骷髏圖紋",
  "block.minecraft.banner.skull.green": "綠色骷髏圖紋",
  "block.minecraft.banner.skull.light_blue": "淺藍色骷髏圖紋",
  "block.minecraft.banner.skull.light_gray": "淺灰色骷髏圖紋",
  "block.minecraft.banner.skull.lime": "淺綠色骷髏圖紋",
  "block.minecraft.banner.skull.magenta": "洋紅色骷髏圖紋",
  "block.minecraft.banner.skull.orange": "橙色骷髏圖紋",
  "block.minecraft.banner.skull.pink": "粉紅色骷髏圖紋",
  "block.minecraft.banner.skull.purple": "紫色骷髏圖紋",
  "block.minecraft.banner.skull.red": "紅色骷髏圖紋",
  "block.minecraft.banner.skull.white": "白色骷髏圖紋",
  "block.minecraft.banner.skull.yellow": "黃色骷髏圖紋",
  "block.minecraft.banner.small_stripes.black": "黑色垂直條紋",
  "block.minecraft.banner.small_stripes.blue": "藍色垂直條紋",
  "block.minecraft.banner.small_stripes.brown": "棕色垂直條紋",
  "block.minecraft.banner.small_stripes.cyan": "青色垂直條紋",
  "block.minecraft.banner.small_stripes.gray": "灰色垂直條紋",
  "block.minecraft.banner.small_stripes.green": "綠色垂直條紋",
  "block.minecraft.banner.small_stripes.light_blue": "淺藍色垂直條紋",
  "block.minecraft.banner.small_stripes.light_gray": "淺灰色垂直條紋",
  "block.minecraft.banner.small_stripes.lime": "淺綠色垂直條紋",
  "block.minecraft.banner.small_stripes.magenta": "洋紅色垂直條紋",
  "block.minecraft.banner.small_stripes.orange": "橙色垂直條紋",
  "block.minecraft.banner.small_stripes.pink": "粉紅色垂直條紋",
  "block.minecraft.banner.small_stripes.purple": "紫色垂直條紋",
  "block.minecraft.banner.small_stripes.red": "紅色垂直條紋",
  "block.minecraft.banner.small_stripes.white": "白色垂直條紋",
  "block.minecraft.banner.small_stripes.yellow": "黃色垂直條紋",
  "block.minecraft.banner.square_bottom_left.black": "左下黑色矩形",
  "block.minecraft.banner.square_bottom_left.blue": "左下藍色矩形",
  "block.minecraft.banner.square_bottom_left.brown": "左下棕色矩形",
  "block.minecraft.banner.square_bottom_left.cyan": "左下青色矩形",
  "block.minecraft.banner.square_bottom_left.gray": "左下灰色矩形",
  "block.minecraft.banner.square_bottom_left.green": "左下綠色矩形",
  "block.minecraft.banner.square_bottom_left.light_blue": "左下淺藍色矩形",
  "block.minecraft.banner.square_bottom_left.light_gray": "左下淺灰色矩形",
  "block.minecraft.banner.square_bottom_left.lime": "左下淺綠色矩形",
  "block.minecraft.banner.square_bottom_left.magenta": "左下洋紅色矩形",
  "block.minecraft.banner.square_bottom_left.orange": "左下橙色矩形",
  "block.minecraft.banner.square_bottom_left.pink": "左下粉紅色矩形",
  "block.minecraft.banner.square_bottom_left.purple": "左下紫色矩形",
  "block.minecraft.banner.square_bottom_left.red": "左下紅色矩形",
  "block.minecraft.banner.square_bottom_left.white": "左下白色矩形",
  "block.minecraft.banner.square_bottom_left.yellow": "左下黃色矩形",
  "block.minecraft.banner.square_bottom_right.black": "右下黑色矩形",
  "block.minecraft.banner.square_bottom_right.blue": "右下藍色矩形",
  "block.minecraft.banner.square_bottom_right.brown": "右下棕色矩形",
  "block.minecraft.banner.square_bottom_right.cyan": "右下青色矩形",
  "block.minecraft.banner.square_bottom_right.gray": "右下灰色矩形",
  "block.minecraft.banner.square_bottom_right.green": "右下綠色矩形",
  "block.minecraft.banner.square_bottom_right.light_blue": "右下淺藍色矩形",
  "block.minecraft.banner.square_bottom_right.light_gray": "右下淺灰色矩形",
  "block.minecraft.banner.square_bottom_right.lime": "右下淺綠色矩形",
  "block.minecraft.banner.square_bottom_right.magenta": "右下洋紅色矩形",
  "block.minecraft.banner.square_bottom_right.orange": "右下橙色矩形",
  "block.minecraft.banner.square_bottom_right.pink": "右下粉紅色矩形",
  "block.minecraft.banner.square_bottom_right.purple": "右下紫色矩形",
  "block.minecraft.banner.square_bottom_right.red": "右下紅色矩形",
  "block.minecraft.banner.square_bottom_right.white": "右下白色矩形",
  "block.minecraft.banner.square_bottom_right.yellow": "右下黃色矩形",
  "block.minecraft.banner.square_top_left.black": "左上黑色矩形",
  "block.minecraft.banner.square_top_left.blue": "左上藍色矩形",
  "block.minecraft.banner.square_top_left.brown": "左上棕色矩形",
  "block.minecraft.banner.square_top_left.cyan": "左上青色矩形",
  "block.minecraft.banner.square_top_left.gray": "左上灰色矩形",
  "block.minecraft.banner.square_top_left.green": "左上綠色矩形",
  "block.minecraft.banner.square_top_left.light_blue": "左上淺藍色矩形",
  "block.minecraft.banner.square_top_left.light_gray": "左上淺灰色矩形",
  "block.minecraft.banner.square_top_left.lime": "左上淺綠色矩形",
  "block.minecraft.banner.square_top_left.magenta": "左上洋紅色矩形",
  "block.minecraft.banner.square_top_left.orange": "左上橙色矩形",
  "block.minecraft.banner.square_top_left.pink": "左上粉紅色矩形",
  "block.minecraft.banner.square_top_left.purple": "左上紫色矩形",
  "block.minecraft.banner.square_top_left.red": "左上紅色矩形",
  "block.minecraft.banner.square_top_left.white": "左上白色矩形",
  "block.minecraft.banner.square_top_left.yellow": "左上黃色矩形",
  "block.minecraft.banner.square_top_right.black": "右上黑色矩形",
  "block.minecraft.banner.square_top_right.blue": "右上藍色矩形",
  "block.minecraft.banner.square_top_right.brown": "右上棕色矩形",
  "block.minecraft.banner.square_top_right.cyan": "右上青色矩形",
  "block.minecraft.banner.square_top_right.gray": "右上灰色矩形",
  "block.minecraft.banner.square_top_right.green": "右上綠色矩形",
  "block.minecraft.banner.square_top_right.light_blue": "右上淺藍色矩形",
  "block.minecraft.banner.square_top_right.light_gray": "右上淺灰色矩形",
  "block.minecraft.banner.square_top_right.lime": "右上淺綠色矩形",
  "block.minecraft.banner.square_top_right.magenta": "右上洋紅色矩形",
  "block.minecraft.banner.square_top_right.orange": "右上橙色矩形",
  "block.minecraft.banner.square_top_right.pink": "右上粉紅色矩形",
  "block.minecraft.banner.square_top_right.purple": "右上紫色矩形",
  "block.minecraft.banner.square_top_right.red": "右上紅色矩形",
  "block.minecraft.banner.square_top_right.white": "右上白色矩形",
  "block.minecraft.banner.square_top_right.yellow": "右上黃色矩形",
  "block.minecraft.banner.straight_cross.black": "黑色十字",
  "block.minecraft.banner.straight_cross.blue": "藍色十字",
  "block.minecraft.banner.straight_cross.brown": "棕色十字",
  "block.minecraft.banner.straight_cross.cyan": "青色十字",
  "block.minecraft.banner.straight_cross.gray": "灰色十字",
  "block.minecraft.banner.straight_cross.green": "綠色十字",
  "block.minecraft.banner.straight_cross.light_blue": "淺藍色十字",
  "block.minecraft.banner.straight_cross.light_gray": "淺灰色十字",
  "block.minecraft.banner.straight_cross.lime": "淺綠色十字",
  "block.minecraft.banner.straight_cross.magenta": "洋紅色十字",
  "block.minecraft.banner.straight_cross.orange": "橙色十字",
  "block.minecraft.banner.straight_cross.pink": "粉紅色十字",
  "block.minecraft.banner.straight_cross.purple": "紫色十字",
  "block.minecraft.banner.straight_cross.red": "紅色十字",
  "block.minecraft.banner.straight_cross.white": "白色十字",
  "block.minecraft.banner.straight_cross.yellow": "黃色十字",
  "block.minecraft.banner.stripe_bottom.black": "黑色底部",
  "block.minecraft.banner.stripe_bottom.blue": "藍色底部",
  "block.minecraft.banner.stripe_bottom.brown": "棕色底部",
  "block.minecraft.banner.stripe_bottom.cyan": "青色底部",
  "block.minecraft.banner.stripe_bottom.gray": "灰色底部",
  "block.minecraft.banner.stripe_bottom.green": "綠色底部",
  "block.minecraft.banner.stripe_bottom.light_blue": "淺藍色底部",
  "block.minecraft.banner.stripe_bottom.light_gray": "淺灰色底部",
  "block.minecraft.banner.stripe_bottom.lime": "淺綠色底部",
  "block.minecraft.banner.stripe_bottom.magenta": "洋紅色底部",
  "block.minecraft.banner.stripe_bottom.orange": "橙色底部",
  "block.minecraft.banner.stripe_bottom.pink": "粉紅色底部",
  "block.minecraft.banner.stripe_bottom.purple": "紫色底部",
  "block.minecraft.banner.stripe_bottom.red": "紅色底部",
  "block.minecraft.banner.stripe_bottom.white": "白色底部",
  "block.minecraft.banner.stripe_bottom.yellow": "黃色底部",
  "block.minecraft.banner.stripe_center.black": "中間黑色縱帶",
  "block.minecraft.banner.stripe_center.blue": "中間藍色縱帶",
  "block.minecraft.banner.stripe_center.brown": "中間棕色縱帶",
  "block.minecraft.banner.stripe_center.cyan": "中間青色縱帶",
  "block.minecraft.banner.stripe_center.gray": "中間灰色縱帶",
  "block.minecraft.banner.stripe_center.green": "中間綠色縱帶",
  "block.minecraft.banner.stripe_center.light_blue": "中間淺藍色縱帶",
  "block.minecraft.banner.stripe_center.light_gray": "中間淺灰色縱帶",
  "block.minecraft.banner.stripe_center.lime": "中間淺綠色縱帶",
  "block.minecraft.banner.stripe_center.magenta": "中間洋紅色縱帶",
  "block.minecraft.banner.stripe_center.orange": "中間橙色縱帶",
  "block.minecraft.banner.stripe_center.pink": "中間粉紅色縱帶",
  "block.minecraft.banner.stripe_center.purple": "中間紫色縱帶",
  "block.minecraft.banner.stripe_center.red": "中間紅色縱帶",
  "block.minecraft.banner.stripe_center.white": "中間白色縱帶",
  "block.minecraft.banner.stripe_center.yellow": "中間黃色縱帶",
  "block.minecraft.banner.stripe_downleft.black": "左斜黑色對角帶",
  "block.minecraft.banner.stripe_downleft.blue": "左斜藍色對角帶",
  "block.minecraft.banner.stripe_downleft.brown": "左斜棕色對角帶",
  "block.minecraft.banner.stripe_downleft.cyan": "左斜青色對角帶",
  "block.minecraft.banner.stripe_downleft.gray": "左斜灰色對角帶",
  "block.minecraft.banner.stripe_downleft.green": "左斜綠色對角帶",
  "block.minecraft.banner.stripe_downleft.light_blue": "左斜淺藍色對角帶",
  "block.minecraft.banner.stripe_downleft.light_gray": "左斜淺灰色對角帶",
  "block.minecraft.banner.stripe_downleft.lime": "左斜淺綠色對角帶",
  "block.minecraft.banner.stripe_downleft.magenta": "左斜洋紅色對角帶",
  "block.minecraft.banner.stripe_downleft.orange": "左斜橙色對角帶",
  "block.minecraft.banner.stripe_downleft.pink": "左斜粉紅色對角帶",
  "block.minecraft.banner.stripe_downleft.purple": "左斜紫色對角帶",
  "block.minecraft.banner.stripe_downleft.red": "左斜紅色對角帶",
  "block.minecraft.banner.stripe_downleft.white": "左斜白色對角帶",
  "block.minecraft.banner.stripe_downleft.yellow": "左斜黃色對角帶",
  "block.minecraft.banner.stripe_downright.black": "右斜黑色對角帶",
  "block.minecraft.banner.stripe_downright.blue": "右斜藍色對角帶",
  "block.minecraft.banner.stripe_downright.brown": "右斜棕色對角帶",
  "block.minecraft.banner.stripe_downright.cyan": "右斜青色對角帶",
  "block.minecraft.banner.stripe_downright.gray": "右斜灰色對角帶",
  "block.minecraft.banner.stripe_downright.green": "右斜綠色對角帶",
  "block.minecraft.banner.stripe_downright.light_blue": "右斜淺藍色對角帶",
  "block.minecraft.banner.stripe_downright.light_gray": "右斜淺灰色對角帶",
  "block.minecraft.banner.stripe_downright.lime": "右斜淺綠色對角帶",
  "block.minecraft.banner.stripe_downright.magenta": "右斜洋紅色對角帶",
  "block.minecraft.banner.stripe_downright.orange": "右斜橙色對角帶",
  "block.minecraft.banner.stripe_downright.pink": "右斜粉紅色對角帶",
  "block.minecraft.banner.stripe_downright.purple": "右斜紫色對角帶",
  "block.minecraft.banner.stripe_downright.red": "右斜紅色對角帶",
  "block.minecraft.banner.stripe_downright.white": "右斜白色對角帶",
  "block.minecraft.banner.stripe_downright.yellow": "右斜黃色對角帶",
  "block.minecraft.banner.stripe_left.black": "左方黑色縱帶",
  "block.minecraft.banner.stripe_left.blue": "左方藍色縱帶",
  "block.minecraft.banner.stripe_left.brown": "左方棕色縱帶",
  "block.minecraft.banner.stripe_left.cyan": "左方青色縱帶",
  "block.minecraft.banner.stripe_left.gray": "左方灰色縱帶",
  "block.minecraft.banner.stripe_left.green": "左方綠色縱帶",
  "block.minecraft.banner.stripe_left.light_blue": "左方淺藍色縱帶",
  "block.minecraft.banner.stripe_left.light_gray": "左方淺灰色縱帶",
  "block.minecraft.banner.stripe_left.lime": "左方淺綠色縱帶",
  "block.minecraft.banner.stripe_left.magenta": "左方洋紅色縱帶",
  "block.minecraft.banner.stripe_left.orange": "左方橙色縱帶",
  "block.minecraft.banner.stripe_left.pink": "左方粉紅色縱帶",
  "block.minecraft.banner.stripe_left.purple": "左方紫色縱帶",
  "block.minecraft.banner.stripe_left.red": "左方紅色縱帶",
  "block.minecraft.banner.stripe_left.white": "左方白色縱帶",
  "block.minecraft.banner.stripe_left.yellow": "左方黃色縱帶",
  "block.minecraft.banner.stripe_middle.black": "中間黑色橫帶",
  "block.minecraft.banner.stripe_middle.blue": "中間藍色橫帶",
  "block.minecraft.banner.stripe_middle.brown": "中間棕色橫帶",
  "block.minecraft.banner.stripe_middle.cyan": "中間青色橫帶",
  "block.minecraft.banner.stripe_middle.gray": "中間灰色橫帶",
  "block.minecraft.banner.stripe_middle.green": "中間綠色橫帶",
  "block.minecraft.banner.stripe_middle.light_blue": "中間淺藍色橫帶",
  "block.minecraft.banner.stripe_middle.light_gray": "中間淺灰色橫帶",
  "block.minecraft.banner.stripe_middle.lime": "中間淺綠色橫帶",
  "block.minecraft.banner.stripe_middle.magenta": "中間洋紅色橫帶",
  "block.minecraft.banner.stripe_middle.orange": "中間橙色橫帶",
  "block.minecraft.banner.stripe_middle.pink": "中間粉紅色橫帶",
  "block.minecraft.banner.stripe_middle.purple": "中間紫色橫帶",
  "block.minecraft.banner.stripe_middle.red": "中間紅色橫帶",
  "block.minecraft.banner.stripe_middle.white": "中間白色橫帶",
  "block.minecraft.banner.stripe_middle.yellow": "中間黃色橫帶",
  "block.minecraft.banner.stripe_right.black": "右方黑色縱帶",
  "block.minecraft.banner.stripe_right.blue": "右方藍色縱帶",
  "block.minecraft.banner.stripe_right.brown": "右方棕色縱帶",
  "block.minecraft.banner.stripe_right.cyan": "右方青色縱帶",
  "block.minecraft.banner.stripe_right.gray": "右方灰色縱帶",
  "block.minecraft.banner.stripe_right.green": "右方綠色縱帶",
  "block.minecraft.banner.stripe_right.light_blue": "右方淺藍色縱帶",
  "block.minecraft.banner.stripe_right.light_gray": "右方淺灰色縱帶",
  "block.minecraft.banner.stripe_right.lime": "右方淺綠色縱帶",
  "block.minecraft.banner.stripe_right.magenta": "右方洋紅色縱帶",
  "block.minecraft.banner.stripe_right.orange": "右方橙色縱帶",
  "block.minecraft.banner.stripe_right.pink": "右方粉紅色縱帶",
  "block.minecraft.banner.stripe_right.purple": "右方紫色縱帶",
  "block.minecraft.banner.stripe_right.red": "右方紅色縱帶",
  "block.minecraft.banner.stripe_right.white": "右方白色縱帶",
  "block.minecraft.banner.stripe_right.yellow": "右方黃色縱帶",
  "block.minecraft.banner.stripe_top.black": "黑色頂部",
  "block.minecraft.banner.stripe_top.blue": "藍色頂部",
  "block.minecraft.banner.stripe_top.brown": "棕色頂部",
  "block.minecraft.banner.stripe_top.cyan": "青色頂部",
  "block.minecraft.banner.stripe_top.gray": "灰色頂部",
  "block.minecraft.banner.stripe_top.green": "綠色頂部",
  "block.minecraft.banner.stripe_top.light_blue": "淺藍色頂部",
  "block.minecraft.banner.stripe_top.light_gray": "淺灰色頂部",
  "block.minecraft.banner.stripe_top.lime": "淺綠色頂部",
  "block.minecraft.banner.stripe_top.magenta": "洋紅色頂部",
  "block.minecraft.banner.stripe_top.orange": "橙色頂部",
  "block.minecraft.banner.stripe_top.pink": "粉紅色頂部",
  "block.minecraft.banner.stripe_top.purple": "紫色頂部",
  "block.minecraft.banner.stripe_top.red": "紅色頂部",
  "block.minecraft.banner.stripe_top.white": "白色頂部",
  "block.minecraft.banner.stripe_top.yellow": "黃色頂部",
  "block.minecraft.banner.triangle_bottom.black": "下方黑色三角形",
  "block.minecraft.banner.triangle_bottom.blue": "下方藍色三角形",
  "block.minecraft.banner.triangle_bottom.brown": "下方棕色三角形",
  "block.minecraft.banner.triangle_bottom.cyan": "下方青色三角形",
  "block.minecraft.banner.triangle_bottom.gray": "下方灰色三角形",
  "block.minecraft.banner.triangle_bottom.green": "下方綠色三角形",
  "block.minecraft.banner.triangle_bottom.light_blue": "下方淺藍色三角形",
  "block.minecraft.banner.triangle_bottom.light_gray": "下方淺灰色三角形",
  "block.minecraft.banner.triangle_bottom.lime": "下方淺綠色三角形",
  "block.minecraft.banner.triangle_bottom.magenta": "下方洋紅色三角形",
  "block.minecraft.banner.triangle_bottom.orange": "下方橙色三角形",
  "block.minecraft.banner.triangle_bottom.pink": "下方粉紅色三角形",
  "block.minecraft.banner.triangle_bottom.purple": "下方紫色三角形",
  "block.minecraft.banner.triangle_bottom.red": "下方紅色三角形",
  "block.minecraft.banner.triangle_bottom.white": "下方白色三角形",
  "block.minecraft.banner.triangle_bottom.yellow": "下方黃色三角形",
  "block.minecraft.banner.triangle_top.black": "上方黑色倒三角形",
  "block.minecraft.banner.triangle_top.blue": "上方藍色倒三角形",
  "block.minecraft.banner.triangle_top.brown": "上方棕色倒三角形",
  "block.minecraft.banner.triangle_top.cyan": "上方青色倒三角形",
  "block.minecraft.banner.triangle_top.gray": "上方灰色倒三角形",
  "block.minecraft.banner.triangle_top.green": "上方綠色倒三角形",
  "block.minecraft.banner.triangle_top.light_blue": "上方淺藍色倒三角形",
  "block.minecraft.banner.triangle_top.light_gray": "上方淺灰色倒三角形",
  "block.minecraft.banner.triangle_top.lime": "上方淺綠色倒三角形",
  "block.minecraft.banner.triangle_top.magenta": "上方洋紅色倒三角形",
  "block.minecraft.banner.triangle_top.orange": "上方橙色倒三角形",
  "block.minecraft.banner.triangle_top.pink": "上方粉紅色倒三角形",
  "block.minecraft.banner.triangle_top.purple": "上方紫色倒三角形",
  "block.minecraft.banner.triangle_top.red": "上方紅色倒三角形",
  "block.minecraft.banner.triangle_top.white": "上方白色倒三角形",
  "block.minecraft.banner.triangle_top.yellow": "上方黃色倒三角形",
  "block.minecraft.banner.triangles_bottom.black": "下側黑色鋸齒",
  "block.minecraft.banner.triangles_bottom.blue": "下側藍色鋸齒",
  "block.minecraft.banner.triangles_bottom.brown": "下側棕色鋸齒",
  "block.minecraft.banner.triangles_bottom.cyan": "下側青色鋸齒",
  "block.minecraft.banner.triangles_bottom.gray": "下側灰色鋸齒",
  "block.minecraft.banner.triangles_bottom.green": "下側綠色鋸齒",
  "block.minecraft.banner.triangles_bottom.light_blue": "下側淺藍色鋸齒",
  "block.minecraft.banner.triangles_bottom.light_gray": "下側淺灰色鋸齒",
  "block.minecraft.banner.triangles_bottom.lime": "下側淺綠色鋸齒",
  "block.minecraft.banner.triangles_bottom.magenta": "下側洋紅色鋸齒",
  "block.minecraft.banner.triangles_bottom.orange": "下側橙色鋸齒",
  "block.minecraft.banner.triangles_bottom.pink": "下側粉紅色鋸齒",
  "block.minecraft.banner.triangles_bottom.purple": "下側紫色鋸齒",
  "block.minecraft.banner.triangles_bottom.red": "下側紅色鋸齒",
  "block.minecraft.banner.triangles_bottom.white": "下側白色鋸齒",
  "block.minecraft.banner.triangles_bottom.yellow": "下側黃色鋸齒",
  "block.minecraft.banner.triangles_top.black": "上側黑色鋸齒",
  "block.minecraft.banner.triangles_top.blue": "上側藍色鋸齒",
  "block.minecraft.banner.triangles_top.brown": "上側棕色鋸齒",
  "block.minecraft.banner.triangles_top.cyan": "上側青色鋸齒",
  "block.minecraft.banner.triangles_top.gray": "上側灰色鋸齒",
  "block.minecraft.banner.triangles_top.green": "上側綠色鋸齒",
  "block.minecraft.banner.triangles_top.light_blue": "上側淺藍色鋸齒",
  "block.minecraft.banner.triangles_top.light_gray": "上側淺灰色鋸齒",
  "block.minecraft.banner.triangles_top.lime": "上側淺綠色鋸齒",
  "block.minecraft.banner.triangles_top.magenta": "上側洋紅色鋸齒",
  "block.minecraft.banner.triangles_top.orange": "上側橙色鋸齒",
  "block.minecraft.banner.triangles_top.pink": "上側粉紅色鋸齒",
  "block.minecraft.banner.triangles_top.purple": "上側紫色鋸齒",
  "block.minecraft.banner.triangles_top.red": "上側紅色鋸齒",
  "block.minecraft.banner.triangles_top.white": "上側白色鋸齒",
  "block.minecraft.banner.triangles_top.yellow": "上側黃色鋸齒",
  "block.minecraft.barrel": "木桶",
  "block.minecraft.barrier": "屏障",
  "block.minecraft.basalt": "玄武岩",
  "block.minecraft.beacon": "烽火台",
  "block.minecraft.beacon.primary": "主要效果",
  "block.minecraft.beacon.secondary": "次要效果",
  "block.minecraft.bed.no_sleep": "你只能在晚上或暴風雨中入睡",
  "block.minecraft.bed.not_safe": "你現在無法休息，附近有怪物在遊蕩",
  "block.minecraft.bed.obstructed": "這張床受到阻擋",
  "block.minecraft.bed.occupied": "這張床已被占用",
  "block.minecraft.bed.too_far_away": "現在無法休息，你離床太遠了",
  "block.minecraft.bedrock": "基岩",
  "block.minecraft.bee_nest": "蜂窩",
  "block.minecraft.beehive": "蜂箱",
  "block.minecraft.beetroots": "甜菜根",
  "block.minecraft.bell": "鐘",
  "block.minecraft.big_dripleaf": "大懸葉草",
  "block.minecraft.big_dripleaf_stem": "大懸葉草葉柄",
  "block.minecraft.birch_button": "樺木按鈕",
  "block.minecraft.birch_door": "樺木門",
  "block.minecraft.birch_fence": "樺木柵欄",
  "block.minecraft.birch_fence_gate": "樺木柵欄門",
  "block.minecraft.birch_hanging_sign": "懸掛式樺木告示牌",
  "block.minecraft.birch_leaves": "樺木樹葉",
  "block.minecraft.birch_log": "樺木原木",
  "block.minecraft.birch_planks": "樺木材",
  "block.minecraft.birch_pressure_plate": "樺木壓力板",
  "block.minecraft.birch_sapling": "樺木樹苗",
  "block.minecraft.birch_shelf": "樺木展示架",
  "block.minecraft.birch_sign": "樺木告示牌",
  "block.minecraft.birch_slab": "樺木半磚",
  "block.minecraft.birch_stairs": "樺木階梯",
  "block.minecraft.birch_trapdoor": "樺木地板門",
  "block.minecraft.birch_wall_hanging_sign": "牆上的懸掛式樺木告示牌",
  "block.minecraft.birch_wall_sign": "牆上的樺木告示牌",
  "block.minecraft.birch_wood": "樺木塊",
  "block.minecraft.black_banner": "黑色旗幟",
  "block.minecraft.black_bed": "黑色床",
  "block.minecraft.black_candle": "黑色蠟燭",
  "block.minecraft.black_candle_cake": "插上黑色蠟燭的蛋糕",
  "block.minecraft.black_carpet": "黑色地毯",
  "block.minecraft.black_concrete": "黑色混凝土",
  "block.minecraft.black_concrete_powder": "黑色混凝土粉末",
  "block.minecraft.black_glazed_terracotta": "黑色釉陶",
  "block.minecraft.black_shulker_box": "黑色界伏盒",
  "block.minecraft.black_stained_glass": "黑色玻璃",
  "block.minecraft.black_stained_glass_pane": "黑色玻璃片",
  "block.minecraft.black_terracotta": "黑色陶土",
  "block.minecraft.black_wool": "黑色羊毛",
  "block.minecraft.blackstone": "黑石",
  "block.minecraft.blackstone_slab": "黑石半磚",
  "block.minecraft.blackstone_stairs": "黑石階梯",
  "block.minecraft.blackstone_wall": "黑石牆",
  "block.minecraft.blast_furnace": "高爐",
  "block.minecraft.blue_banner": "藍色旗幟",
  "block.minecraft.blue_bed": "藍色床",
  "block.minecraft.blue_candle": "藍色蠟燭",
  "block.minecraft.blue_candle_cake": "插上藍色蠟燭的蛋糕",
  "block.minecraft.blue_carpet": "藍色地毯",
  "block.minecraft.blue_concrete": "藍色混凝土",
  "block.minecraft.blue_concrete_powder": "藍色混凝土粉末",
  "block.minecraft.blue_glazed_terracotta": "藍色釉陶",
  "block.minecraft.blue_ice": "藍冰",
  "block.minecraft.blue_orchid": "藍色蝴蝶蘭",
  "block.minecraft.blue_shulker_box": "藍色界伏盒",
  "block.minecraft.blue_stained_glass": "藍色玻璃",
  "block.minecraft.blue_stained_glass_pane": "藍色玻璃片",
  "block.minecraft.blue_terracotta": "藍色陶土",
  "block.minecraft.blue_wool": "藍色羊毛",
  "block.minecraft.bone_block": "骨塊",
  "block.minecraft.bookshelf": "書櫃",
  "block.minecraft.brain_coral": "腦珊瑚",
  "block.minecraft.brain_coral_block": "腦珊瑚方塊",
  "block.minecraft.brain_coral_fan": "扇狀腦珊瑚",
  "block.minecraft.brain_coral_wall_fan": "牆上的扇狀腦珊瑚",
  "block.minecraft.brewing_stand": "釀造台",
  "block.minecraft.brick_slab": "紅磚半磚",
  "block.minecraft.brick_stairs": "紅磚階梯",
  "block.minecraft.brick_wall": "紅磚牆",
  "block.minecraft.bricks": "紅磚",
  "block.minecraft.brown_banner": "棕色旗幟",
  "block.minecraft.brown_bed": "棕色床",
  "block.minecraft.brown_candle": "棕色蠟燭",
  "block.minecraft.brown_candle_cake": "插上棕色蠟燭的蛋糕",
  "block.minecraft.brown_carpet": "棕色地毯",
  "block.minecraft.brown_concrete": "棕色混凝土",
  "block.minecraft.brown_concrete_powder": "棕色混凝土粉末",
  "block.minecraft.brown_glazed_terracotta": "棕色釉陶",
  "block.minecraft.brown_mushroom": "棕色蘑菇",
  "block.minecraft.brown_mushroom_block": "棕色蘑菇方塊",
  "block.minecraft.brown_shulker_box": "棕色界伏盒",
  "block.minecraft.brown_stained_glass": "棕色玻璃",
  "block.minecraft.brown_stained_glass_pane": "棕色玻璃片",
  "block.minecraft.brown_terracotta": "棕色陶土",
  "block.minecraft.brown_wool": "棕色羊毛",
  "block.minecraft.bubble_column": "氣泡柱",
  "block.minecraft.bubble_coral": "氣泡珊瑚",
  "block.minecraft.bubble_coral_block": "氣泡珊瑚方塊",
  "block.minecraft.bubble_coral_fan": "扇狀氣泡珊瑚",
  "block.minecraft.bubble_coral_wall_fan": "牆上的扇狀氣泡珊瑚",
  "block.minecraft.budding_amethyst": "紫水晶芽床",
  "block.minecraft.bush": "灌木叢",
  "block.minecraft.cactus": "仙人掌",
  "block.minecraft.cactus_flower": "仙人掌花",
  "block.minecraft.cake": "蛋糕",
  "block.minecraft.calcite": "方解石",
  "block.minecraft.calibrated_sculk_sensor": "校準伏聆振測器",
  "block.minecraft.campfire": "營火",
  "block.minecraft.candle": "蠟燭",
  "block.minecraft.candle_cake": "插上蠟燭的蛋糕",
  "block.minecraft.carrots": "胡蘿蔔",
  "block.minecraft.cartography_table": "製圖台",
  "block.minecraft.carved_pumpkin": "雕刻過的南瓜",
  "block.minecraft.cauldron": "鍋釜",
  "block.minecraft.cave_air": "洞穴空氣",
  "block.minecraft.cave_vines": "洞穴藤蔓",
  "block.minecraft.cave_vines_plant": "洞穴藤蔓植株",
  "block.minecraft.chain": "鎖鏈",
  "block.minecraft.chain_command_block": "連鎖式指令方塊",
  "block.minecraft.cherry_button": "櫻花木按鈕",
  "block.minecraft.cherry_door": "櫻花木門",
  "block.minecraft.cherry_fence": "櫻花木柵欄",
  "block.minecraft.cherry_fence_gate": "櫻花木柵欄門",
  "block.minecraft.cherry_hanging_sign": "懸掛式櫻花木告示牌",
  "block.minecraft.cherry_leaves": "櫻花木樹葉",
  "block.minecraft.cherry_log": "櫻花木原木",
  "block.minecraft.cherry_planks": "櫻花木材",
  "block.minecraft.cherry_pressure_plate": "櫻花木壓力板",
  "block.minecraft.cherry_sapling": "櫻花木樹苗",
  "block.minecraft.cherry_shelf": "櫻花木展示架",
  "block.minecraft.cherry_sign": "櫻花木告示牌",
  "block.minecraft.cherry_slab": "櫻花木半磚",
  "block.minecraft.cherry_stairs": "櫻花木階梯",
  "block.minecraft.cherry_trapdoor": "櫻花木地板門",
  "block.minecraft.cherry_wall_hanging_sign": "牆上的懸掛式櫻花木告示牌",
  "block.minecraft.cherry_wall_sign": "牆上的櫻花木告示牌",
  "block.minecraft.cherry_wood": "櫻花木塊",
  "block.minecraft.chest": "儲物箱",
  "block.minecraft.chipped_anvil": "微損的鐵砧",
  "block.minecraft.chiseled_bookshelf": "浮雕書櫃",
  "block.minecraft.chiseled_copper": "浮雕銅方塊",
  "block.minecraft.chiseled_deepslate": "浮雕深板岩",
  "block.minecraft.chiseled_nether_bricks": "浮雕地獄磚",
  "block.minecraft.chiseled_polished_blackstone": "浮雕拋光黑石",
  "block.minecraft.chiseled_quartz_block": "浮雕石英方塊",
  "block.minecraft.chiseled_red_sandstone": "浮雕紅砂岩",
  "block.minecraft.chiseled_resin_bricks": "浮雕樹脂磚",
  "block.minecraft.chiseled_sandstone": "浮雕砂岩",
  "block.minecraft.chiseled_stone_bricks": "浮雕石磚",
  "block.minecraft.chiseled_tuff": "浮雕凝灰岩",
  "block.minecraft.chiseled_tuff_bricks": "浮雕凝灰岩磚",
  "block.minecraft.chorus_flower": "歌萊花",
  "block.minecraft.chorus_plant": "歌萊枝",
  "block.minecraft.clay": "黏土",
  "block.minecraft.closed_eyeblossom": "閉合的擬目花",
  "block.minecraft.coal_block": "煤炭方塊",
  "block.minecraft.coal_ore": "煤礦",
  "block.minecraft.coarse_dirt": "粗泥",
  "block.minecraft.cobbled_deepslate": "深板岩碎石",
  "block.minecraft.cobbled_deepslate_slab": "碎深板岩半磚",
  "block.minecraft.cobbled_deepslate_stairs": "碎深板岩階梯",
  "block.minecraft.cobbled_deepslate_wall": "碎深板岩牆",
  "block.minecraft.cobblestone": "鵝卵石",
  "block.minecraft.cobblestone_slab": "鵝卵石半磚",
  "block.minecraft.cobblestone_stairs": "鵝卵石階梯",
  "block.minecraft.cobblestone_wall": "鵝卵石牆",
  "block.minecraft.cobweb": "蜘蛛網",
  "block.minecraft.cocoa": "可可豆",
  "block.minecraft.command_block": "指令方塊",
  "block.minecraft.comparator": "紅石比較器",
  "block.minecraft.composter": "堆肥箱",
  "block.minecraft.conduit": "海靈核心",
  "block.minecraft.copper_bars": "銅柵欄",
  "block.minecraft.copper_block": "銅方塊",
  "block.minecraft.copper_bulb": "銅燈",
  "block.minecraft.copper_chain": "銅鏈",
  "block.minecraft.copper_chest": "銅儲物箱",
  "block.minecraft.copper_door": "銅門",
  "block.minecraft.copper_golem_statue": "銅像",
  "block.minecraft.copper_grate": "銅格柵",
  "block.minecraft.copper_lantern": "銅燈籠",
  "block.minecraft.copper_ore": "銅礦",
  "block.minecraft.copper_torch": "銅火把",
  "block.minecraft.copper_trapdoor": "銅地板門",
  "block.minecraft.copper_wall_torch": "牆上的銅火把",
  "block.minecraft.cornflower": "矢車菊",
  "block.minecraft.cracked_deepslate_bricks": "裂紋深板岩磚",
  "block.minecraft.cracked_deepslate_tiles": "裂紋深板岩磚瓦",
  "block.minecraft.cracked_nether_bricks": "裂紋地獄磚",
  "block.minecraft.cracked_polished_blackstone_bricks": "裂紋拋光黑石磚",
  "block.minecraft.cracked_stone_bricks": "裂紋石磚",
  "block.minecraft.crafter": "合成器",
  "block.minecraft.crafting_table": "工作台",
  "block.minecraft.creaking_heart": "嘎枝之心",
  "block.minecraft.creeper_head": "苦力怕頭顱",
  "block.minecraft.creeper_wall_head": "牆上的苦力怕頭顱",
  "block.minecraft.crimson_button": "緋紅蕈木按鈕",
  "block.minecraft.crimson_door": "緋紅蕈木門",
  "block.minecraft.crimson_fence": "緋紅蕈木柵欄",
  "block.minecraft.crimson_fence_gate": "緋紅蕈木柵欄門",
  "block.minecraft.crimson_fungus": "緋紅蕈菇",
  "block.minecraft.crimson_hanging_sign": "懸掛式緋紅蕈木告示牌",
  "block.minecraft.crimson_hyphae": "緋紅菌絲體",
  "block.minecraft.crimson_nylium": "緋紅菌絲石",
  "block.minecraft.crimson_planks": "緋紅蕈木材",
  "block.minecraft.crimson_pressure_plate": "緋紅蕈木壓力板",
  "block.minecraft.crimson_roots": "緋紅蕈根",
  "block.minecraft.crimson_shelf": "緋紅蕈木展示架",
  "block.minecraft.crimson_sign": "緋紅蕈木告示牌",
  "block.minecraft.crimson_slab": "緋紅蕈木半磚",
  "block.minecraft.crimson_stairs": "緋紅蕈木階梯",
  "block.minecraft.crimson_stem": "緋紅蕈柄",
  "block.minecraft.crimson_trapdoor": "緋紅蕈木地板門",
  "block.minecraft.crimson_wall_hanging_sign": "牆上的懸掛式緋紅蕈木告示牌",
  "block.minecraft.crimson_wall_sign": "牆上的緋紅蕈木告示牌",
  "block.minecraft.crying_obsidian": "哭泣的黑曜石",
  "block.minecraft.cut_copper": "切製銅方塊",
  "block.minecraft.cut_copper_slab": "切製銅半磚",
  "block.minecraft.cut_copper_stairs": "切製銅階梯",
  "block.minecraft.cut_red_sandstone": "切製紅砂岩",
  "block.minecraft.cut_red_sandstone_slab": "切製紅砂岩半磚",
  "block.minecraft.cut_sandstone": "切製砂岩",
  "block.minecraft.cut_sandstone_slab": "切製砂岩半磚",
  "block.minecraft.cyan_banner": "青色旗幟",
  "block.minecraft.cyan_bed": "青色床",
  "block.minecraft.cyan_candle": "青色蠟燭",
  "block.minecraft.cyan_candle_cake": "插上青色蠟燭的蛋糕",
  "block.minecraft.cyan_carpet": "青色地毯",
  "block.minecraft.cyan_concrete": "青色混凝土",
  "block.minecraft.cyan_concrete_powder": "青色混凝土粉末",
  "block.minecraft.cyan_glazed_terracotta": "青色釉陶",
  "block.minecraft.cyan_shulker_box": "青色界伏盒",
  "block.minecraft.cyan_stained_glass": "青色玻璃",
  "block.minecraft.cyan_stained_glass_pane": "青色玻璃片",
  "block.minecraft.cyan_terracotta": "青色陶土",
  "block.minecraft.cyan_wool": "青色羊毛",
  "block.minecraft.damaged_anvil": "耗損的鐵砧",
  "block.minecraft.dandelion": "蒲公英",
  "block.minecraft.dark_oak_button": "黑橡木按鈕",
  "block.minecraft.dark_oak_door": "黑橡木門",
  "block.minecraft.dark_oak_fence": "黑橡木柵欄",
  "block.minecraft.dark_oak_fence_gate": "黑橡木柵欄門",
  "block.minecraft.dark_oak_hanging_sign": "懸掛式黑橡木告示牌",
  "block.minecraft.dark_oak_leaves": "黑橡木樹葉",
  "block.minecraft.dark_oak_log": "黑橡木原木",
  "block.minecraft.dark_oak_planks": "黑橡木材",
  "block.minecraft.dark_oak_pressure_plate": "黑橡木壓力板",
  "block.minecraft.dark_oak_sapling": "黑橡木樹苗",
  "block.minecraft.dark_oak_shelf": "黑橡木展示架",
  "block.minecraft.dark_oak_sign": "黑橡木告示牌",
  "block.minecraft.dark_oak_slab": "黑橡木半磚",
  "block.minecraft.dark_oak_stairs": "黑橡木階梯",
  "block.minecraft.dark_oak_trapdoor": "黑橡木地板門",
  "block.minecraft.dark_oak_wall_hanging_sign": "牆上的懸掛式黑橡木告示牌",
  "block.minecraft.dark_oak_wall_sign": "牆上的黑橡木告示牌",
  "block.minecraft.dark_oak_wood": "黑橡木塊",
  "block.minecraft.dark_prismarine": "暗海磷石",
  "block.minecraft.dark_prismarine_slab": "暗海磷石半磚",
  "block.minecraft.dark_prismarine_stairs": "暗海磷石階梯",
  "block.minecraft.daylight_detector": "日光感測器",
  "block.minecraft.dead_brain_coral": "死亡的腦珊瑚",
  "block.minecraft.dead_brain_coral_block": "死亡的腦珊瑚方塊",
  "block.minecraft.dead_brain_coral_fan": "死亡的扇狀腦珊瑚",
  "block.minecraft.dead_brain_coral_wall_fan": "牆上死亡的扇狀腦珊瑚",
  "block.minecraft.dead_bubble_coral": "死亡的氣泡珊瑚",
  "block.minecraft.dead_bubble_coral_block": "死亡的氣泡珊瑚方塊",
  "block.minecraft.dead_bubble_coral_fan": "死亡的扇狀氣泡珊瑚",
  "block.minecraft.dead_bubble_coral_wall_fan": "牆上死亡的扇狀氣泡珊瑚",
  "block.minecraft.dead_bush": "枯灌木",
  "block.minecraft.dead_fire_coral": "死亡的火珊瑚",
  "block.minecraft.dead_fire_coral_block": "死亡的火珊瑚方塊",
  "block.minecraft.dead_fire_coral_fan": "死亡的扇狀火珊瑚",
  "block.minecraft.dead_fire_coral_wall_fan": "牆上死亡的扇狀火珊瑚",
  "block.minecraft.dead_horn_coral": "死亡的角珊瑚",
  "block.minecraft.dead_horn_coral_block": "死亡的角珊瑚方塊",
  "block.minecraft.dead_horn_coral_fan": "死亡的扇狀角珊瑚",
  "block.minecraft.dead_horn_coral_wall_fan": "牆上死亡的扇狀角珊瑚",
  "block.minecraft.dead_tube_coral": "死亡的管珊瑚",
  "block.minecraft.dead_tube_coral_block": "死亡的管珊瑚方塊",
  "block.minecraft.dead_tube_coral_fan": "死亡的扇狀管珊瑚",
  "block.minecraft.dead_tube_coral_wall_fan": "牆上死亡的扇狀管珊瑚",
  "block.minecraft.decorated_pot": "飾紋陶罐",
  "block.minecraft.deepslate": "深板岩",
  "block.minecraft.deepslate_brick_slab": "深板岩磚半磚",
  "block.minecraft.deepslate_brick_stairs": "深板岩磚階梯",
  "block.minecraft.deepslate_brick_wall": "深板岩磚牆",
  "block.minecraft.deepslate_bricks": "深板岩磚",
  "block.minecraft.deepslate_coal_ore": "深板岩煤礦",
  "block.minecraft.deepslate_copper_ore": "深板岩銅礦",
  "block.minecraft.deepslate_diamond_ore": "深板岩鑽石礦",
  "block.minecraft.deepslate_emerald_ore": "深板岩綠寶石礦",
  "block.minecraft.deepslate_gold_ore": "深板岩金礦",
  "block.minecraft.deepslate_iron_ore": "深板岩鐵礦",
  "block.minecraft.deepslate_lapis_ore": "深板岩青金石礦",
  "block.minecraft.deepslate_redstone_ore": "深板岩紅石礦",
  "block.minecraft.deepslate_tile_slab": "深板岩磚瓦半磚",
  "block.minecraft.deepslate_tile_stairs": "深板岩磚瓦階梯",
  "block.minecraft.deepslate_tile_wall": "深板岩磚瓦牆",
  "block.minecraft.deepslate_tiles": "深板岩磚瓦",
  "block.minecraft.detector_rail": "感測鐵軌",
  "block.minecraft.diamond_block": "鑽石方塊",
  "block.minecraft.diamond_ore": "鑽石礦",
  "block.minecraft.diorite": "閃長岩",
  "block.minecraft.diorite_slab": "閃長岩半磚",
  "block.minecraft.diorite_stairs": "閃長岩階梯",
  "block.minecraft.diorite_wall": "閃長岩牆",
  "block.minecraft.dirt": "泥土",
  "block.minecraft.dirt_path": "土徑",
  "block.minecraft.dispenser": "發射器",
  "block.minecraft.dragon_egg": "龍蛋",
  "block.minecraft.dragon_head": "龍首",
  "block.minecraft.dragon_wall_head": "牆上的龍首",
  "block.minecraft.dried_ghast": "乾癟幽靈",
  "block.minecraft.dried_kelp_block": "海帶乾塊",
  "block.minecraft.dripstone_block": "鐘乳石方塊",
  "block.minecraft.dropper": "投擲器",
  "block.minecraft.emerald_block": "綠寶石方塊",
  "block.minecraft.emerald_ore": "綠寶石礦",
  "block.minecraft.enchanting_table": "附魔台",
  "block.minecraft.end_gateway": "終界折躍門",
  "block.minecraft.end_portal": "終界傳送門",
  "block.minecraft.end_portal_frame": "終界傳送門框架",
  "block.minecraft.end_rod": "終界燭",
  "block.minecraft.end_stone": "終界石",
  "block.minecraft.end_stone_brick_slab": "終界石磚半磚",
  "block.minecraft.end_stone_brick_stairs": "終界石磚階梯",
  "block.minecraft.end_stone_brick_wall": "終界石磚牆",
  "block.minecraft.end_stone_bricks": "終界石磚",
  "block.minecraft.ender_chest": "終界箱",
  "block.minecraft.exposed_chiseled_copper": "斑駁的浮雕銅方塊",
  "block.minecraft.exposed_copper": "斑駁的銅方塊",
  "block.minecraft.exposed_copper_bars": "斑駁的銅柵欄",
  "block.minecraft.exposed_copper_bulb": "斑駁的銅燈",
  "block.minecraft.exposed_copper_chain": "斑駁的銅鏈",
  "block.minecraft.exposed_copper_chest": "斑駁的銅儲物箱",
  "block.minecraft.exposed_copper_door": "斑駁的銅門",
  "block.minecraft.exposed_copper_golem_statue": "斑駁的銅像",
  "block.minecraft.exposed_copper_grate": "斑駁的銅格柵",
  "block.minecraft.exposed_copper_lantern": "斑駁的銅燈籠",
  "block.minecraft.exposed_copper_trapdoor": "斑駁的銅地板門",
  "block.minecraft.exposed_cut_copper": "斑駁的切製銅方塊",
  "block.minecraft.exposed_cut_copper_slab": "斑駁的切製銅半磚",
  "block.minecraft.exposed_cut_copper_stairs": "斑駁的切製銅階梯",
  "block.minecraft.exposed_lightning_rod": "斑駁的避雷針",
  "block.minecraft.farmland": "耕地",
  "block.minecraft.fern": "蕨",
  "block.minecraft.fire": "火",
  "block.minecraft.fire_coral": "火珊瑚",
  "block.minecraft.fire_coral_block": "火珊瑚方塊",
  "block.minecraft.fire_coral_fan": "扇狀火珊瑚",
  "block.minecraft.fire_coral_wall_fan": "牆上的扇狀火珊瑚",
  "block.minecraft.firefly_bush": "螢火蟲灌木叢",
  "block.minecraft.fletching_table": "製箭台",
  "block.minecraft.flower_pot": "花盆",
  "block.minecraft.flowering_azalea": "開花的杜鵑叢",
  "block.minecraft.flowering_azalea_leaves": "開花的杜鵑葉",
  "block.minecraft.frogspawn": "青蛙卵",
  "block.minecraft.frosted_ice": "霜冰",
  "block.minecraft.furnace": "熔爐",
  "block.minecraft.gilded_blackstone": "鑲金黑石",
  "block.minecraft.glass": "玻璃",
  "block.minecraft.glass_pane": "玻璃片",
  "block.minecraft.glow_lichen": "發光地衣",
  "block.minecraft.glowstone": "螢光石",
  "block.minecraft.gold_block": "黃金方塊",
  "block.minecraft.gold_ore": "金礦",
  "block.minecraft.golden_dandelion": "金蒲公英",
  "block.minecraft.granite": "花崗岩",
  "block.minecraft.granite_slab": "花崗岩半磚",
  "block.minecraft.granite_stairs": "花崗岩階梯",
  "block.minecraft.granite_wall": "花崗岩牆",
  "block.minecraft.grass": "草",
  "block.minecraft.grass_block": "草地",
  "block.minecraft.gravel": "礫石",
  "block.minecraft.gray_banner": "灰色旗幟",
  "block.minecraft.gray_bed": "灰色床",
  "block.minecraft.gray_candle": "灰色蠟燭",
  "block.minecraft.gray_candle_cake": "插上灰色蠟燭的蛋糕",
  "block.minecraft.gray_carpet": "灰色地毯",
  "block.minecraft.gray_concrete": "灰色混凝土",
  "block.minecraft.gray_concrete_powder": "灰色混凝土粉末",
  "block.minecraft.gray_glazed_terracotta": "灰色釉陶",
  "block.minecraft.gray_shulker_box": "灰色界伏盒",
  "block.minecraft.gray_stained_glass": "灰色玻璃",
  "block.minecraft.gray_stained_glass_pane": "灰色玻璃片",
  "block.minecraft.gray_terracotta": "灰色陶土",
  "block.minecraft.gray_wool": "灰色羊毛",
  "block.minecraft.green_banner": "綠色旗幟",
  "block.minecraft.green_bed": "綠色床",
  "block.minecraft.green_candle": "綠色蠟燭",
  "block.minecraft.green_candle_cake": "插上綠色蠟燭的蛋糕",
  "block.minecraft.green_carpet": "綠色地毯",
  "block.minecraft.green_concrete": "綠色混凝土",
  "block.minecraft.green_concrete_powder": "綠色混凝土粉末",
  "block.minecraft.green_glazed_terracotta": "綠色釉陶",
  "block.minecraft.green_shulker_box": "綠色界伏盒",
  "block.minecraft.green_stained_glass": "綠色玻璃",
  "block.minecraft.green_stained_glass_pane": "綠色玻璃片",
  "block.minecraft.green_terracotta": "綠色陶土",
  "block.minecraft.green_wool": "綠色羊毛",
  "block.minecraft.grindstone": "砂輪",
  "block.minecraft.hanging_roots": "懸根",
  "block.minecraft.hay_block": "乾草捆",
  "block.minecraft.heavy_core": "沉重核心",
  "block.minecraft.heavy_weighted_pressure_plate": "重質測重壓力板",
  "block.minecraft.honey_block": "蜂蜜塊",
  "block.minecraft.honeycomb_block": "蜂巢塊",
  "block.minecraft.hopper": "漏斗",
  "block.minecraft.horn_coral": "角珊瑚",
  "block.minecraft.horn_coral_block": "角珊瑚方塊",
  "block.minecraft.horn_coral_fan": "扇狀角珊瑚",
  "block.minecraft.horn_coral_wall_fan": "牆上的扇狀角珊瑚",
  "block.minecraft.ice": "冰",
  "block.minecraft.infested_chiseled_stone_bricks": "蛀蝕的浮雕石磚",
  "block.minecraft.infested_cobblestone": "蛀蝕的鵝卵石",
  "block.minecraft.infested_cracked_stone_bricks": "蛀蝕的裂紋石磚",
  "block.minecraft.infested_deepslate": "蛀蝕的深板岩",
  "block.minecraft.infested_mossy_stone_bricks": "蛀蝕的青苔石磚",
  "block.minecraft.infested_stone": "蛀蝕的石頭",
  "block.minecraft.infested_stone_bricks": "蛀蝕的石磚",
  "block.minecraft.iron_bars": "鐵柵欄",
  "block.minecraft.iron_block": "鐵方塊",
  "block.minecraft.iron_chain": "鐵鏈",
  "block.minecraft.iron_door": "鐵門",
  "block.minecraft.iron_ore": "鐵礦",
  "block.minecraft.iron_trapdoor": "鐵地板門",
  "block.minecraft.jack_o_lantern": "南瓜燈",
  "block.minecraft.jigsaw": "拼圖方塊",
  "block.minecraft.jukebox": "唱片機",
  "block.minecraft.jungle_button": "叢林木按鈕",
  "block.minecraft.jungle_door": "叢林木門",
  "block.minecraft.jungle_fence": "叢林木柵欄",
  "block.minecraft.jungle_fence_gate": "叢林木柵欄門",
  "block.minecraft.jungle_hanging_sign": "懸掛式叢林木告示牌",
  "block.minecraft.jungle_leaves": "叢林木樹葉",
  "block.minecraft.jungle_log": "叢林木原木",
  "block.minecraft.jungle_planks": "叢林木材",
  "block.minecraft.jungle_pressure_plate": "叢林木壓力板",
  "block.minecraft.jungle_sapling": "叢林木樹苗",
  "block.minecraft.jungle_shelf": "叢林木展示架",
  "block.minecraft.jungle_sign": "叢林木告示牌",
  "block.minecraft.jungle_slab": "叢林木半磚",
  "block.minecraft.jungle_stairs": "叢林木階梯",
  "block.minecraft.jungle_trapdoor": "叢林木地板門",
  "block.minecraft.jungle_wall_hanging_sign": "牆上的懸掛式叢林木告示牌",
  "block.minecraft.jungle_wall_sign": "牆上的叢林木告示牌",
  "block.minecraft.jungle_wood": "叢林木塊",
  "block.minecraft.kelp": "海帶",
  "block.minecraft.kelp_plant": "海帶植株",
  "block.minecraft.ladder": "梯子",
  "block.minecraft.lantern": "燈籠",
  "block.minecraft.lapis_block": "青金石方塊",
  "block.minecraft.lapis_ore": "青金石礦",
  "block.minecraft.large_amethyst_bud": "大型紫水晶芽",
  "block.minecraft.large_fern": "大型蕨類",
  "block.minecraft.lava": "熔岩",
  "block.minecraft.lava_cauldron": "裝熔岩的鍋釜",
  "block.minecraft.leaf_litter": "枯葉",
  "block.minecraft.lectern": "講台",
  "block.minecraft.lever": "控制桿",
  "block.minecraft.light": "光源",
  "block.minecraft.light_blue_banner": "淺藍色旗幟",
  "block.minecraft.light_blue_bed": "淺藍色床",
  "block.minecraft.light_blue_candle": "淺藍色蠟燭",
  "block.minecraft.light_blue_candle_cake": "插上淺藍色蠟燭的蛋糕",
  "block.minecraft.light_blue_carpet": "淺藍色地毯",
  "block.minecraft.light_blue_concrete": "淺藍色混凝土",
  "block.minecraft.light_blue_concrete_powder": "淺藍色混凝土粉末",
  "block.minecraft.light_blue_glazed_terracotta": "淺藍色釉陶",
  "block.minecraft.light_blue_shulker_box": "淺藍色界伏盒",
  "block.minecraft.light_blue_stained_glass": "淺藍色玻璃",
  "block.minecraft.light_blue_stained_glass_pane": "淺藍色玻璃片",
  "block.minecraft.light_blue_terracotta": "淺藍色陶土",
  "block.minecraft.light_blue_wool": "淺藍色羊毛",
  "block.minecraft.light_gray_banner": "淺灰色旗幟",
  "block.minecraft.light_gray_bed": "淺灰色床",
  "block.minecraft.light_gray_candle": "淺灰色蠟燭",
  "block.minecraft.light_gray_candle_cake": "插上淺灰色蠟燭的蛋糕",
  "block.minecraft.light_gray_carpet": "淺灰色地毯",
  "block.minecraft.light_gray_concrete": "淺灰色混凝土",
  "block.minecraft.light_gray_concrete_powder": "淺灰色混凝土粉末",
  "block.minecraft.light_gray_glazed_terracotta": "淺灰色釉陶",
  "block.minecraft.light_gray_shulker_box": "淺灰色界伏盒",
  "block.minecraft.light_gray_stained_glass": "淺灰色玻璃",
  "block.minecraft.light_gray_stained_glass_pane": "淺灰色玻璃片",
  "block.minecraft.light_gray_terracotta": "淺灰色陶土",
  "block.minecraft.light_gray_wool": "淺灰色羊毛",
  "block.minecraft.light_weighted_pressure_plate": "輕質測重壓力板",
  "block.minecraft.lightning_rod": "避雷針",
  "block.minecraft.lilac": "紫丁香",
  "block.minecraft.lily_of_the_valley": "鈴蘭",
  "block.minecraft.lily_pad": "荷葉",
  "block.minecraft.lime_banner": "淺綠色旗幟",
  "block.minecraft.lime_bed": "淺綠色床",
  "block.minecraft.lime_candle": "淺綠色蠟燭",
  "block.minecraft.lime_candle_cake": "插上淺綠色蠟燭的蛋糕",
  "block.minecraft.lime_carpet": "淺綠色地毯",
  "block.minecraft.lime_concrete": "淺綠色混凝土",
  "block.minecraft.lime_concrete_powder": "淺綠色混凝土粉末",
  "block.minecraft.lime_glazed_terracotta": "淺綠色釉陶",
  "block.minecraft.lime_shulker_box": "淺綠色界伏盒",
  "block.minecraft.lime_stained_glass": "淺綠色玻璃",
  "block.minecraft.lime_stained_glass_pane": "淺綠色玻璃片",
  "block.minecraft.lime_terracotta": "淺綠色陶土",
  "block.minecraft.lime_wool": "淺綠色羊毛",
  "block.minecraft.lodestone": "磁石",
  "block.minecraft.loom": "紡織機",
  "block.minecraft.magenta_banner": "洋紅色旗幟",
  "block.minecraft.magenta_bed": "洋紅色床",
  "block.minecraft.magenta_candle": "洋紅色蠟燭",
  "block.minecraft.magenta_candle_cake": "插上洋紅色蠟燭的蛋糕",
  "block.minecraft.magenta_carpet": "洋紅色地毯",
  "block.minecraft.magenta_concrete": "洋紅色混凝土",
  "block.minecraft.magenta_concrete_powder": "洋紅色混凝土粉末",
  "block.minecraft.magenta_glazed_terracotta": "洋紅色釉陶",
  "block.minecraft.magenta_shulker_box": "洋紅色界伏盒",
  "block.minecraft.magenta_stained_glass": "洋紅色玻璃",
  "block.minecraft.magenta_stained_glass_pane": "洋紅色玻璃片",
  "block.minecraft.magenta_terracotta": "洋紅色陶土",
  "block.minecraft.magenta_wool": "洋紅色羊毛",
  "block.minecraft.magma_block": "岩漿塊",
  "block.minecraft.mangrove_button": "紅樹林木按鈕",
  "block.minecraft.mangrove_door": "紅樹林木門",
  "block.minecraft.mangrove_fence": "紅樹林木柵欄",
  "block.minecraft.mangrove_fence_gate": "紅樹林木柵欄門",
  "block.minecraft.mangrove_hanging_sign": "懸掛式紅樹林木告示牌",
  "block.minecraft.mangrove_leaves": "紅樹林木樹葉",
  "block.minecraft.mangrove_log": "紅樹林木原木",
  "block.minecraft.mangrove_planks": "紅樹林木材",
  "block.minecraft.mangrove_pressure_plate": "紅樹林木壓力板",
  "block.minecraft.mangrove_propagule": "紅樹林木胎生苗",
  "block.minecraft.mangrove_roots": "紅樹林木根",
  "block.minecraft.mangrove_shelf": "紅樹林木展示架",
  "block.minecraft.mangrove_sign": "紅樹林木告示牌",
  "block.minecraft.mangrove_slab": "紅樹林木半磚",
  "block.minecraft.mangrove_stairs": "紅樹林木階梯",
  "block.minecraft.mangrove_trapdoor": "紅樹林木地板門",
  "block.minecraft.mangrove_wall_hanging_sign": "牆上的懸掛式紅樹林木告示牌",
  "block.minecraft.mangrove_wall_sign": "牆上的紅樹林木告示牌",
  "block.minecraft.mangrove_wood": "紅樹林木塊",
  "block.minecraft.medium_amethyst_bud": "中型紫水晶芽",
  "block.minecraft.melon": "西瓜",
  "block.minecraft.melon_stem": "西瓜梗",
  "block.minecraft.moss_block": "苔蘚方塊",
  "block.minecraft.moss_carpet": "覆地苔蘚",
  "block.minecraft.mossy_cobblestone": "青苔鵝卵石",
  "block.minecraft.mossy_cobblestone_slab": "青苔鵝卵石半磚",
  "block.minecraft.mossy_cobblestone_stairs": "青苔鵝卵石階梯",
  "block.minecraft.mossy_cobblestone_wall": "青苔鵝卵石牆",
  "block.minecraft.mossy_stone_brick_slab": "青苔石磚半磚",
  "block.minecraft.mossy_stone_brick_stairs": "青苔石磚階梯",
  "block.minecraft.mossy_stone_brick_wall": "青苔石磚牆",
  "block.minecraft.mossy_stone_bricks": "青苔石磚",
  "block.minecraft.moving_piston": "移動中的活塞",
  "block.minecraft.mud": "泥巴",
  "block.minecraft.mud_brick_slab": "泥磚半磚",
  "block.minecraft.mud_brick_stairs": "泥磚階梯",
  "block.minecraft.mud_brick_wall": "泥磚牆",
  "block.minecraft.mud_bricks": "泥磚",
  "block.minecraft.muddy_mangrove_roots": "淤泥紅樹林木根",
  "block.minecraft.mushroom_stem": "蘑菇柄",
  "block.minecraft.mycelium": "菌絲土",
  "block.minecraft.nether_brick_fence": "地獄磚柵欄",
  "block.minecraft.nether_brick_slab": "地獄磚半磚",
  "block.minecraft.nether_brick_stairs": "地獄磚階梯",
  "block.minecraft.nether_brick_wall": "地獄磚牆",
  "block.minecraft.nether_bricks": "地獄磚",
  "block.minecraft.nether_gold_ore": "地獄金礦",
  "block.minecraft.nether_portal": "地獄傳送門",
  "block.minecraft.nether_quartz_ore": "地獄石英礦",
  "block.minecraft.nether_sprouts": "地獄芽",
  "block.minecraft.nether_wart": "地獄疙瘩",
  "block.minecraft.nether_wart_block": "地獄疙瘩塊",
  "block.minecraft.netherite_block": "獄髓方塊",
  "block.minecraft.netherrack": "地獄石",
  "block.minecraft.note_block": "音階盒",
  "block.minecraft.oak_button": "橡木按鈕",
  "block.minecraft.oak_door": "橡木門",
  "block.minecraft.oak_fence": "橡木柵欄",
  "block.minecraft.oak_fence_gate": "橡木柵欄門",
  "block.minecraft.oak_hanging_sign": "懸掛式橡木告示牌",
  "block.minecraft.oak_leaves": "橡木樹葉",
  "block.minecraft.oak_log": "橡木原木",
  "block.minecraft.oak_planks": "橡木材",
  "block.minecraft.oak_pressure_plate": "橡木壓力板",
  "block.minecraft.oak_sapling": "橡木樹苗",
  "block.minecraft.oak_shelf": "橡木展示架",
  "block.minecraft.oak_sign": "橡木告示牌",
  "block.minecraft.oak_slab": "橡木半磚",
  "block.minecraft.oak_stairs": "橡木階梯",
  "block.minecraft.oak_trapdoor": "橡木地板門",
  "block.minecraft.oak_wall_hanging_sign": "牆上的懸掛式橡木告示牌",
  "block.minecraft.oak_wall_sign": "牆上的橡木告示牌",
  "block.minecraft.oak_wood": "橡木塊",
  "block.minecraft.observer": "偵測器",
  "block.minecraft.obsidian": "黑曜石",
  "block.minecraft.ochre_froglight": "赭黃蛙光體",
  "block.minecraft.ominous_banner": "不祥旗幟",
  "block.minecraft.open_eyeblossom": "張開的擬目花",
  "block.minecraft.orange_banner": "橙色旗幟",
  "block.minecraft.orange_bed": "橙色床",
  "block.minecraft.orange_candle": "橙色蠟燭",
  "block.minecraft.orange_candle_cake": "插上橙色蠟燭的蛋糕",
  "block.minecraft.orange_carpet": "橙色地毯",
  "block.minecraft.orange_concrete": "橙色混凝土",
  "block.minecraft.orange_concrete_powder": "橙色混凝土粉末",
  "block.minecraft.orange_glazed_terracotta": "橙色釉陶",
  "block.minecraft.orange_shulker_box": "橙色界伏盒",
  "block.minecraft.orange_stained_glass": "橙色玻璃",
  "block.minecraft.orange_stained_glass_pane": "橙色玻璃片",
  "block.minecraft.orange_terracotta": "橙色陶土",
  "block.minecraft.orange_tulip": "橙色鬱金香",
  "block.minecraft.orange_wool": "橙色羊毛",
  "block.minecraft.oxeye_daisy": "雛菊",
  "block.minecraft.oxidized_chiseled_copper": "氧化的浮雕銅方塊",
  "block.minecraft.oxidized_copper": "氧化的銅方塊",
  "block.minecraft.oxidized_copper_bars": "氧化的銅柵欄",
  "block.minecraft.oxidized_copper_bulb": "氧化的銅燈",
  "block.minecraft.oxidized_copper_chain": "氧化的銅鏈",
  "block.minecraft.oxidized_copper_chest": "氧化的銅儲物箱",
  "block.minecraft.oxidized_copper_door": "氧化的銅門",
  "block.minecraft.oxidized_copper_golem_statue": "氧化的銅像",
  "block.minecraft.oxidized_copper_grate": "氧化的銅格柵",
  "block.minecraft.oxidized_copper_lantern": "氧化的銅燈籠",
  "block.minecraft.oxidized_copper_trapdoor": "氧化的銅地板門",
  "block.minecraft.oxidized_cut_copper": "氧化的切製銅方塊",
  "block.minecraft.oxidized_cut_copper_slab": "氧化的切製銅半磚",
  "block.minecraft.oxidized_cut_copper_stairs": "氧化的切製銅階梯",
  "block.minecraft.oxidized_lightning_rod": "氧化的避雷針",
  "block.minecraft.packed_ice": "冰磚",
  "block.minecraft.packed_mud": "泥坯",
  "block.minecraft.pale_hanging_moss": "蒼白垂絲",
  "block.minecraft.pale_moss_block": "蒼白苔蘚方塊",
  "block.minecraft.pale_moss_carpet": "蒼白覆地苔蘚",
  "block.minecraft.pale_oak_button": "蒼白橡木按鈕",
  "block.minecraft.pale_oak_door": "蒼白橡木門",
  "block.minecraft.pale_oak_fence": "蒼白橡木柵欄",
  "block.minecraft.pale_oak_fence_gate": "蒼白橡木柵欄門",
  "block.minecraft.pale_oak_hanging_sign": "懸掛式蒼白橡木告示牌",
  "block.minecraft.pale_oak_leaves": "蒼白橡木樹葉",
  "block.minecraft.pale_oak_log": "蒼白橡木原木",
  "block.minecraft.pale_oak_planks": "蒼白橡木材",
  "block.minecraft.pale_oak_pressure_plate": "蒼白橡木壓力板",
  "block.minecraft.pale_oak_sapling": "蒼白橡木樹苗",
  "block.minecraft.pale_oak_shelf": "蒼白橡木展示架",
  "block.minecraft.pale_oak_sign": "蒼白橡木告示牌",
  "block.minecraft.pale_oak_slab": "蒼白橡木半磚",
  "block.minecraft.pale_oak_stairs": "蒼白橡木階梯",
  "block.minecraft.pale_oak_trapdoor": "蒼白橡木地板門",
  "block.minecraft.pale_oak_wall_hanging_sign": "牆上的懸掛式蒼白橡木告示牌",
  "block.minecraft.pale_oak_wall_sign": "牆上的蒼白橡木告示牌",
  "block.minecraft.pale_oak_wood": "蒼白橡木塊",
  "block.minecraft.pearlescent_froglight": "珠紫蛙光體",
  "block.minecraft.peony": "牡丹花",
  "block.minecraft.petrified_oak_slab": "石化橡木半磚",
  "block.minecraft.piglin_head": "豬布林頭顱",
  "block.minecraft.piglin_wall_head": "牆上的豬布林頭顱",
  "block.minecraft.pink_banner": "粉紅色旗幟",
  "block.minecraft.pink_bed": "粉紅色床",
  "block.minecraft.pink_candle": "粉紅色蠟燭",
  "block.minecraft.pink_candle_cake": "插上粉紅色蠟燭的蛋糕",
  "block.minecraft.pink_carpet": "粉紅色地毯",
  "block.minecraft.pink_concrete": "粉紅色混凝土",
  "block.minecraft.pink_concrete_powder": "粉紅色混凝土粉末",
  "block.minecraft.pink_glazed_terracotta": "粉紅色釉陶",
  "block.minecraft.pink_petals": "粉瓣花",
  "block.minecraft.pink_shulker_box": "粉紅色界伏盒",
  "block.minecraft.pink_stained_glass": "粉紅色玻璃",
  "block.minecraft.pink_stained_glass_pane": "粉紅色玻璃片",
  "block.minecraft.pink_terracotta": "粉紅色陶土",
  "block.minecraft.pink_tulip": "粉紅色鬱金香",
  "block.minecraft.pink_wool": "粉紅色羊毛",
  "block.minecraft.piston": "活塞",
  "block.minecraft.piston_head": "活塞頭",
  "block.minecraft.pitcher_crop": "瓶子草植株",
  "block.minecraft.pitcher_plant": "瓶子草",
  "block.minecraft.player_head": "玩家頭顱",
  "block.minecraft.player_head.named": "%s 的頭顱",
  "block.minecraft.player_wall_head": "牆上的玩家頭顱",
  "block.minecraft.podzol": "灰壤",
  "block.minecraft.pointed_dripstone": "鐘乳石",
  "block.minecraft.polished_andesite": "拋光安山岩",
  "block.minecraft.polished_andesite_slab": "拋光安山岩半磚",
  "block.minecraft.polished_andesite_stairs": "拋光安山岩階梯",
  "block.minecraft.polished_basalt": "拋光玄武岩",
  "block.minecraft.polished_blackstone": "拋光黑石",
  "block.minecraft.polished_blackstone_brick_slab": "拋光黑石磚半磚",
  "block.minecraft.polished_blackstone_brick_stairs": "拋光黑石磚階梯",
  "block.minecraft.polished_blackstone_brick_wall": "拋光黑石磚牆",
  "block.minecraft.polished_blackstone_bricks": "拋光黑石磚",
  "block.minecraft.polished_blackstone_button": "拋光黑石按鈕",
  "block.minecraft.polished_blackstone_pressure_plate": "拋光黑石壓力板",
  "block.minecraft.polished_blackstone_slab": "拋光黑石半磚",
  "block.minecraft.polished_blackstone_stairs": "拋光黑石階梯",
  "block.minecraft.polished_blackstone_wall": "拋光黑石牆",
  "block.minecraft.polished_deepslate": "拋光深板岩",
  "block.minecraft.polished_deepslate_slab": "拋光深板岩半磚",
  "block.minecraft.polished_deepslate_stairs": "拋光深板岩階梯",
  "block.minecraft.polished_deepslate_wall": "拋光深板岩牆",
  "block.minecraft.polished_diorite": "拋光閃長岩",
  "block.minecraft.polished_diorite_slab": "拋光閃長岩半磚",
  "block.minecraft.polished_diorite_stairs": "拋光閃長岩階梯",
  "block.minecraft.polished_granite": "拋光花崗岩",
  "block.minecraft.polished_granite_slab": "拋光花崗岩半磚",
  "block.minecraft.polished_granite_stairs": "拋光花崗岩階梯",
  "block.minecraft.polished_tuff": "拋光凝灰岩",
  "block.minecraft.polished_tuff_slab": "拋光凝灰岩半磚",
  "block.minecraft.polished_tuff_stairs": "拋光凝灰岩階梯",
  "block.minecraft.polished_tuff_wall": "拋光凝灰岩牆",
  "block.minecraft.poppy": "罌粟",
  "block.minecraft.potatoes": "馬鈴薯",
  "block.minecraft.potted_acacia_sapling": "相思木樹苗盆栽",
  "block.minecraft.potted_allium": "紫紅球花盆栽",
  "block.minecraft.potted_azalea_bush": "杜鵑叢盆栽",
  "block.minecraft.potted_azure_bluet": "雛草盆栽",
  "block.minecraft.potted_bamboo": "竹子盆栽",
  "block.minecraft.potted_birch_sapling": "樺木樹苗盆栽",
  "block.minecraft.potted_blue_orchid": "藍色蝴蝶蘭盆栽",
  "block.minecraft.potted_brown_mushroom": "棕色蘑菇盆栽",
  "block.minecraft.potted_cactus": "仙人掌盆栽",
  "block.minecraft.potted_cherry_sapling": "櫻花木樹苗盆栽",
  "block.minecraft.potted_closed_eyeblossom": "閉合的擬目花盆栽",
  "block.minecraft.potted_cornflower": "矢車菊盆栽",
  "block.minecraft.potted_crimson_fungus": "緋紅蕈菇盆栽",
  "block.minecraft.potted_crimson_roots": "緋紅蕈根盆栽",
  "block.minecraft.potted_dandelion": "蒲公英盆栽",
  "block.minecraft.potted_dark_oak_sapling": "黑橡木樹苗盆栽",
  "block.minecraft.potted_dead_bush": "枯灌木盆栽",
  "block.minecraft.potted_fern": "蕨類盆栽",
  "block.minecraft.potted_flowering_azalea_bush": "開花的杜鵑叢盆栽",
  "block.minecraft.potted_golden_dandelion": "金蒲公英盆栽",
  "block.minecraft.potted_jungle_sapling": "叢林木樹苗盆栽",
  "block.minecraft.potted_lily_of_the_valley": "鈴蘭盆栽",
  "block.minecraft.potted_mangrove_propagule": "紅樹林木胎生苗盆栽",
  "block.minecraft.potted_oak_sapling": "橡木樹苗盆栽",
  "block.minecraft.potted_open_eyeblossom": "張開的擬目花盆栽",
  "block.minecraft.potted_orange_tulip": "橙色鬱金香盆栽",
  "block.minecraft.potted_oxeye_daisy": "雛菊盆栽",
  "block.minecraft.potted_pale_oak_sapling": "蒼白橡木樹苗盆栽",
  "block.minecraft.potted_pink_tulip": "粉紅色鬱金香盆栽",
  "block.minecraft.potted_poppy": "罌粟盆栽",
  "block.minecraft.potted_red_mushroom": "紅色蘑菇盆栽",
  "block.minecraft.potted_red_tulip": "紅色鬱金香盆栽",
  "block.minecraft.potted_spruce_sapling": "杉木樹苗盆栽",
  "block.minecraft.potted_torchflower": "火把花盆栽",
  "block.minecraft.potted_warped_fungus": "扭曲蕈菇盆栽",
  "block.minecraft.potted_warped_roots": "扭曲蕈根盆栽",
  "block.minecraft.potted_white_tulip": "白色鬱金香盆栽",
  "block.minecraft.potted_wither_rose": "凋零玫瑰盆栽",
  "block.minecraft.powder_snow": "粉雪",
  "block.minecraft.powder_snow_cauldron": "裝粉雪的鍋釜",
  "block.minecraft.powered_rail": "動力鐵軌",
  "block.minecraft.prismarine": "海磷石",
  "block.minecraft.prismarine_brick_slab": "海磷石磚半磚",
  "block.minecraft.prismarine_brick_stairs": "海磷石磚階梯",
  "block.minecraft.prismarine_bricks": "海磷石磚",
  "block.minecraft.prismarine_slab": "海磷石半磚",
  "block.minecraft.prismarine_stairs": "海磷石階梯",
  "block.minecraft.prismarine_wall": "海磷石牆",
  "block.minecraft.pumpkin": "南瓜",
  "block.minecraft.pumpkin_stem": "南瓜梗",
  "block.minecraft.purple_banner": "紫色旗幟",
  "block.minecraft.purple_bed": "紫色床",
  "block.minecraft.purple_candle": "紫色蠟燭",
  "block.minecraft.purple_candle_cake": "插上紫色蠟燭的蛋糕",
  "block.minecraft.purple_carpet": "紫色地毯",
  "block.minecraft.purple_concrete": "紫色混凝土",
  "block.minecraft.purple_concrete_powder": "紫色混凝土粉末",
  "block.minecraft.purple_glazed_terracotta": "紫色釉陶",
  "block.minecraft.purple_shulker_box": "紫色界伏盒",
  "block.minecraft.purple_stained_glass": "紫色玻璃",
  "block.minecraft.purple_stained_glass_pane": "紫色玻璃片",
  "block.minecraft.purple_terracotta": "紫色陶土",
  "block.minecraft.purple_wool": "紫色羊毛",
  "block.minecraft.purpur_block": "紫珀方塊",
  "block.minecraft.purpur_pillar": "紫珀柱",
  "block.minecraft.purpur_slab": "紫珀半磚",
  "block.minecraft.purpur_stairs": "紫珀階梯",
  "block.minecraft.quartz_block": "石英方塊",
  "block.minecraft.quartz_bricks": "石英磚",
  "block.minecraft.quartz_pillar": "石英柱",
  "block.minecraft.quartz_slab": "石英半磚",
  "block.minecraft.quartz_stairs": "石英階梯",
  "block.minecraft.rail": "鐵軌",
  "block.minecraft.raw_copper_block": "銅原礦方塊",
  "block.minecraft.raw_gold_block": "金原礦方塊",
  "block.minecraft.raw_iron_block": "鐵原礦方塊",
  "block.minecraft.red_banner": "紅色旗幟",
  "block.minecraft.red_bed": "紅色床",
  "block.minecraft.red_candle": "紅色蠟燭",
  "block.minecraft.red_candle_cake": "插上紅色蠟燭的蛋糕",
  "block.minecraft.red_carpet": "紅色地毯",
  "block.minecraft.red_concrete": "紅色混凝土",
  "block.minecraft.red_concrete_powder": "紅色混凝土粉末",
  "block.minecraft.red_glazed_terracotta": "紅色釉陶",
  "block.minecraft.red_mushroom": "紅色蘑菇",
  "block.minecraft.red_mushroom_block": "紅色蘑菇方塊",
  "block.minecraft.red_nether_brick_slab": "紅地獄磚半磚",
  "block.minecraft.red_nether_brick_stairs": "紅地獄磚階梯",
  "block.minecraft.red_nether_brick_wall": "紅地獄磚牆",
  "block.minecraft.red_nether_bricks": "紅地獄磚",
  "block.minecraft.red_sand": "紅沙",
  "block.minecraft.red_sandstone": "紅砂岩",
  "block.minecraft.red_sandstone_slab": "紅砂岩半磚",
  "block.minecraft.red_sandstone_stairs": "紅砂岩階梯",
  "block.minecraft.red_sandstone_wall": "紅砂岩牆",
  "block.minecraft.red_shulker_box": "紅色界伏盒",
  "block.minecraft.red_stained_glass": "紅色玻璃",
  "block.minecraft.red_stained_glass_pane": "紅色玻璃片",
  "block.minecraft.red_terracotta": "紅色陶土",
  "block.minecraft.red_tulip": "紅色鬱金香",
  "block.minecraft.red_wool": "紅色羊毛",
  "block.minecraft.redstone_block": "紅石方塊",
  "block.minecraft.redstone_lamp": "紅石燈",
  "block.minecraft.redstone_ore": "紅石礦",
  "block.minecraft.redstone_torch": "紅石火把",
  "block.minecraft.redstone_wall_torch": "牆上的紅石火把",
  "block.minecraft.redstone_wire": "紅石線",
  "block.minecraft.reinforced_deepslate": "強化深板岩",
  "block.minecraft.repeater": "紅石中繼器",
  "block.minecraft.repeating_command_block": "重複型指令方塊",
  "block.minecraft.resin_block": "樹脂方塊",
  "block.minecraft.resin_brick_slab": "樹脂磚半磚",
  "block.minecraft.resin_brick_stairs": "樹脂磚階梯",
  "block.minecraft.resin_brick_wall": "樹脂磚牆",
  "block.minecraft.resin_bricks": "樹脂磚",
  "block.minecraft.resin_clump": "樹脂團",
  "block.minecraft.respawn_anchor": "重生錨",
  "block.minecraft.rooted_dirt": "扎根土",
  "block.minecraft.rose_bush": "玫瑰叢",
  "block.minecraft.sand": "沙",
  "block.minecraft.sandstone": "砂岩",
  "block.minecraft.sandstone_slab": "砂岩半磚",
  "block.minecraft.sandstone_stairs": "砂岩階梯",
  "block.minecraft.sandstone_wall": "砂岩牆",
  "block.minecraft.scaffolding": "鷹架",
  "block.minecraft.sculk": "伏聆",
  "block.minecraft.sculk_catalyst": "伏聆觸媒",
  "block.minecraft.sculk_sensor": "伏聆振測器",
  "block.minecraft.sculk_shrieker": "伏聆嘯口",
  "block.minecraft.sculk_vein": "伏聆脈絡",
  "block.minecraft.sea_lantern": "海燈籠",
  "block.minecraft.sea_pickle": "海鞘",
  "block.minecraft.seagrass": "海草",
  "block.minecraft.set_spawn": "已設定重生點",
  "block.minecraft.short_dry_grass": "矮枯草",
  "block.minecraft.short_grass": "矮草",
  "block.minecraft.shroomlight": "蕈光體",
  "block.minecraft.shulker_box": "界伏盒",
  "block.minecraft.skeleton_skull": "骷髏頭顱",
  "block.minecraft.skeleton_wall_skull": "牆上的骷髏頭顱",
  "block.minecraft.slime_block": "史萊姆方塊",
  "block.minecraft.small_amethyst_bud": "小型紫水晶芽",
  "block.minecraft.small_dripleaf": "小懸葉草",
  "block.minecraft.smithing_table": "鍛造台",
  "block.minecraft.smoker": "煙燻爐",
  "block.minecraft.smooth_basalt": "平滑玄武岩",
  "block.minecraft.smooth_quartz": "平滑石英方塊",
  "block.minecraft.smooth_quartz_slab": "平滑石英半磚",
  "block.minecraft.smooth_quartz_stairs": "平滑石英階梯",
  "block.minecraft.smooth_red_sandstone": "平滑紅砂岩",
  "block.minecraft.smooth_red_sandstone_slab": "平滑紅砂岩半磚",
  "block.minecraft.smooth_red_sandstone_stairs": "平滑紅砂岩階梯",
  "block.minecraft.smooth_sandstone": "平滑砂岩",
  "block.minecraft.smooth_sandstone_slab": "平滑砂岩半磚",
  "block.minecraft.smooth_sandstone_stairs": "平滑砂岩階梯",
  "block.minecraft.smooth_stone": "平滑石頭",
  "block.minecraft.smooth_stone_slab": "平滑石半磚",
  "block.minecraft.sniffer_egg": "嗅探獸蛋",
  "block.minecraft.snow": "雪",
  "block.minecraft.snow_block": "雪塊",
  "block.minecraft.soul_campfire": "靈魂營火",
  "block.minecraft.soul_fire": "靈魂火",
  "block.minecraft.soul_lantern": "靈魂燈籠",
  "block.minecraft.soul_sand": "靈魂砂",
  "block.minecraft.soul_soil": "靈魂土",
  "block.minecraft.soul_torch": "靈魂火把",
  "block.minecraft.soul_wall_torch": "牆上的靈魂火把",
  "block.minecraft.spawn.not_valid": "你沒有床或已充能的重生錨，或是它受到阻擋",
  "block.minecraft.spawner": "生怪磚",
  "block.minecraft.spawner.desc1": "用生怪蛋互動時：",
  "block.minecraft.spawner.desc2": "設定生物種類",
  "block.minecraft.sponge": "海綿",
  "block.minecraft.spore_blossom": "孢子花",
  "block.minecraft.spruce_button": "杉木按鈕",
  "block.minecraft.spruce_door": "杉木門",
  "block.minecraft.spruce_fence": "杉木柵欄",
  "block.minecraft.spruce_fence_gate": "杉木柵欄門",
  "block.minecraft.spruce_hanging_sign": "懸掛式杉木告示牌",
  "block.minecraft.spruce_leaves": "杉木樹葉",
  "block.minecraft.spruce_log": "杉木原木",
  "block.minecraft.spruce_planks": "杉木材",
  "block.minecraft.spruce_pressure_plate": "杉木壓力板",
  "block.minecraft.spruce_sapling": "杉木樹苗",
  "block.minecraft.spruce_shelf": "杉木展示架",
  "block.minecraft.spruce_sign": "杉木告示牌",
  "block.minecraft.spruce_slab": "杉木半磚",
  "block.minecraft.spruce_stairs": "杉木階梯",
  "block.minecraft.spruce_trapdoor": "杉木地板門",
  "block.minecraft.spruce_wall_hanging_sign": "牆上的懸掛式杉木告示牌",
  "block.minecraft.spruce_wall_sign": "牆上的杉木告示牌",
  "block.minecraft.spruce_wood": "杉木塊",
  "block.minecraft.sticky_piston": "黏性活塞",
  "block.minecraft.stone": "石頭",
  "block.minecraft.stone_brick_slab": "石磚半磚",
  "block.minecraft.stone_brick_stairs": "石磚階梯",
  "block.minecraft.stone_brick_wall": "石磚牆",
  "block.minecraft.stone_bricks": "石磚",
  "block.minecraft.stone_button": "石製按鈕",
  "block.minecraft.stone_pressure_plate": "石製壓力板",
  "block.minecraft.stone_slab": "石半磚",
  "block.minecraft.stone_stairs": "石頭階梯",
  "block.minecraft.stonecutter": "切石機",
  "block.minecraft.stripped_acacia_log": "剝皮相思木原木",
  "block.minecraft.stripped_acacia_wood": "剝皮相思木塊",
  "block.minecraft.stripped_bamboo_block": "剝皮竹方塊",
  "block.minecraft.stripped_birch_log": "剝皮樺木原木",
  "block.minecraft.stripped_birch_wood": "剝皮樺木塊",
  "block.minecraft.stripped_cherry_log": "剝皮櫻花木原木",
  "block.minecraft.stripped_cherry_wood": "剝皮櫻花木塊",
  "block.minecraft.stripped_crimson_hyphae": "剝皮緋紅菌絲體",
  "block.minecraft.stripped_crimson_stem": "剝皮緋紅蕈柄",
  "block.minecraft.stripped_dark_oak_log": "剝皮黑橡木原木",
  "block.minecraft.stripped_dark_oak_wood": "剝皮黑橡木塊",
  "block.minecraft.stripped_jungle_log": "剝皮叢林木原木",
  "block.minecraft.stripped_jungle_wood": "剝皮叢林木塊",
  "block.minecraft.stripped_mangrove_log": "剝皮紅樹林木原木",
  "block.minecraft.stripped_mangrove_wood": "剝皮紅樹林木塊",
  "block.minecraft.stripped_oak_log": "剝皮橡木原木",
  "block.minecraft.stripped_oak_wood": "剝皮橡木塊",
  "block.minecraft.stripped_pale_oak_log": "剝皮蒼白橡木原木",
  "block.minecraft.stripped_pale_oak_wood": "剝皮蒼白橡木塊",
  "block.minecraft.stripped_spruce_log": "剝皮杉木原木",
  "block.minecraft.stripped_spruce_wood": "剝皮杉木塊",
  "block.minecraft.stripped_warped_hyphae": "剝皮扭曲菌絲體",
  "block.minecraft.stripped_warped_stem": "剝皮扭曲蕈柄",
  "block.minecraft.structure_block": "結構方塊",
  "block.minecraft.structure_void": "結構空位",
  "block.minecraft.sugar_cane": "甘蔗",
  "block.minecraft.sunflower": "向日葵",
  "block.minecraft.suspicious_gravel": "可疑的礫石",
  "block.minecraft.suspicious_sand": "可疑的沙",
  "block.minecraft.sweet_berry_bush": "甜莓灌木叢",
  "block.minecraft.tall_dry_grass": "高枯草",
  "block.minecraft.tall_grass": "芒草",
  "block.minecraft.tall_seagrass": "高海草",
  "block.minecraft.target": "標靶",
  "block.minecraft.terracotta": "陶土",
  "block.minecraft.test_block": "測試方塊",
  "block.minecraft.test_instance_block": "測試實例方塊",
  "block.minecraft.tinted_glass": "遮光玻璃",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT 爆炸已停用",
  "block.minecraft.torch": "火把",
  "block.minecraft.torchflower": "火把花",
  "block.minecraft.torchflower_crop": "火把花植株",
  "block.minecraft.trapped_chest": "陷阱儲物箱",
  "block.minecraft.trial_spawner": "試煉生怪磚",
  "block.minecraft.tripwire": "絆線",
  "block.minecraft.tripwire_hook": "絆線鉤",
  "block.minecraft.tube_coral": "管珊瑚",
  "block.minecraft.tube_coral_block": "管珊瑚方塊",
  "block.minecraft.tube_coral_fan": "扇狀管珊瑚",
  "block.minecraft.tube_coral_wall_fan": "牆上的扇狀管珊瑚",
  "block.minecraft.tuff": "凝灰岩",
  "block.minecraft.tuff_brick_slab": "凝灰岩磚半磚",
  "block.minecraft.tuff_brick_stairs": "凝灰岩磚階梯",
  "block.minecraft.tuff_brick_wall": "凝灰岩磚牆",
  "block.minecraft.tuff_bricks": "凝灰岩磚",
  "block.minecraft.tuff_slab": "凝灰岩半磚",
  "block.minecraft.tuff_stairs": "凝灰岩階梯",
  "block.minecraft.tuff_wall": "凝灰岩牆",
  "block.minecraft.turtle_egg": "海龜蛋",
  "block.minecraft.twisting_vines": "扭曲藤",
  "block.minecraft.twisting_vines_plant": "扭曲藤植株",
  "block.minecraft.vault": "寶庫",
  "block.minecraft.verdant_froglight": "蒼翠蛙光體",
  "block.minecraft.vine": "藤蔓",
  "block.minecraft.void_air": "虛空空氣",
  "block.minecraft.wall_torch": "牆上的火把",
  "block.minecraft.warped_button": "扭曲蕈木按鈕",
  "block.minecraft.warped_door": "扭曲蕈木門",
  "block.minecraft.warped_fence": "扭曲蕈木柵欄",
  "block.minecraft.warped_fence_gate": "扭曲蕈木柵欄門",
  "block.minecraft.warped_fungus": "扭曲蕈菇",
  "block.minecraft.warped_hanging_sign": "懸掛式扭曲蕈木告示牌",
  "block.minecraft.warped_hyphae": "扭曲菌絲體",
  "block.minecraft.warped_nylium": "扭曲菌絲石",
  "block.minecraft.warped_planks": "扭曲蕈木材",
  "block.minecraft.warped_pressure_plate": "扭曲蕈木壓力板",
  "block.minecraft.warped_roots": "扭曲蕈根",
  "block.minecraft.warped_shelf": "扭曲蕈木展示架",
  "block.minecraft.warped_sign": "扭曲蕈木告示牌",
  "block.minecraft.warped_slab": "扭曲蕈木半磚",
  "block.minecraft.warped_stairs": "扭曲蕈木階梯",
  "block.minecraft.warped_stem": "扭曲蕈柄",
  "block.minecraft.warped_trapdoor": "扭曲蕈木地板門",
  "block.minecraft.warped_wall_hanging_sign": "牆上的懸掛式扭曲蕈木告示牌",
  "block.minecraft.warped_wall_sign": "牆上的扭曲蕈木告示牌",
  "block.minecraft.warped_wart_block": "扭曲疙瘩塊",
  "block.minecraft.water": "水",
  "block.minecraft.water_cauldron": "裝水的鍋釜",
  "block.minecraft.waxed_chiseled_copper": "上蠟的浮雕銅方塊",
  "block.minecraft.waxed_copper_bars": "上蠟的銅柵欄",
  "block.minecraft.waxed_copper_block": "上蠟的銅方塊",
  "block.minecraft.waxed_copper_bulb": "上蠟的銅燈",
  "block.minecraft.waxed_copper_chain": "上蠟的銅鏈",
  "block.minecraft.waxed_copper_chest": "上蠟的銅儲物箱",
  "block.minecraft.waxed_copper_door": "上蠟的銅門",
  "block.minecraft.waxed_copper_golem_statue": "上蠟的銅像",
  "block.minecraft.waxed_copper_grate": "上蠟的銅格柵",
  "block.minecraft.waxed_copper_lantern": "上蠟的銅燈籠",
  "block.minecraft.waxed_copper_trapdoor": "上蠟的銅地板門",
  "block.minecraft.waxed_cut_copper": "上蠟的切製銅方塊",
  "block.minecraft.waxed_cut_copper_slab": "上蠟的切製銅半磚",
  "block.minecraft.waxed_cut_copper_stairs": "上蠟的切製銅階梯",
  "block.minecraft.waxed_exposed_chiseled_copper": "上蠟的斑駁浮雕銅方塊",
  "block.minecraft.waxed_exposed_copper": "上蠟的斑駁銅方塊",
  "block.minecraft.waxed_exposed_copper_bars": "上蠟的斑駁銅柵欄",
  "block.minecraft.waxed_exposed_copper_bulb": "上蠟的斑駁銅燈",
  "block.minecraft.waxed_exposed_copper_chain": "上蠟的斑駁銅鏈",
  "block.minecraft.waxed_exposed_copper_chest": "上蠟的斑駁銅儲物箱",
  "block.minecraft.waxed_exposed_copper_door": "上蠟的斑駁銅門",
  "block.minecraft.waxed_exposed_copper_golem_statue": "上蠟的斑駁銅像",
  "block.minecraft.waxed_exposed_copper_grate": "上蠟的斑駁銅格柵",
  "block.minecraft.waxed_exposed_copper_lantern": "上蠟的斑駁銅燈籠",
  "block.minecraft.waxed_exposed_copper_trapdoor": "上蠟的斑駁銅地板門",
  "block.minecraft.waxed_exposed_cut_copper": "上蠟的斑駁切製銅方塊",
  "block.minecraft.waxed_exposed_cut_copper_slab": "上蠟的斑駁切製銅半磚",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "上蠟的斑駁切製銅階梯",
  "block.minecraft.waxed_exposed_lightning_rod": "上蠟的斑駁避雷針",
  "block.minecraft.waxed_lightning_rod": "上蠟的避雷針",
  "block.minecraft.waxed_oxidized_chiseled_copper": "上蠟的氧化浮雕銅方塊",
  "block.minecraft.waxed_oxidized_copper": "上蠟的氧化銅方塊",
  "block.minecraft.waxed_oxidized_copper_bars": "上蠟的氧化銅柵欄",
  "block.minecraft.waxed_oxidized_copper_bulb": "上蠟的氧化銅燈",
  "block.minecraft.waxed_oxidized_copper_chain": "上蠟的氧化銅鏈",
  "block.minecraft.waxed_oxidized_copper_chest": "上蠟的氧化銅儲物箱",
  "block.minecraft.waxed_oxidized_copper_door": "上蠟的氧化銅門",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "上蠟的氧化銅像",
  "block.minecraft.waxed_oxidized_copper_grate": "上蠟的氧化銅格柵",
  "block.minecraft.waxed_oxidized_copper_lantern": "上蠟的氧化銅燈籠",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "上蠟的氧化銅地板門",
  "block.minecraft.waxed_oxidized_cut_copper": "上蠟的氧化切製銅方塊",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "上蠟的氧化切製銅半磚",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "上蠟的氧化切製銅階梯",
  "block.minecraft.waxed_oxidized_lightning_rod": "上蠟的氧化避雷針",
  "block.minecraft.waxed_weathered_chiseled_copper": "上蠟的風化浮雕銅方塊",
  "block.minecraft.waxed_weathered_copper": "上蠟的風化銅方塊",
  "block.minecraft.waxed_weathered_copper_bars": "上蠟的風化銅柵欄",
  "block.minecraft.waxed_weathered_copper_bulb": "上蠟的風化銅燈",
  "block.minecraft.waxed_weathered_copper_chain": "上蠟的風化銅鏈",
  "block.minecraft.waxed_weathered_copper_chest": "上蠟的風化銅儲物箱",
  "block.minecraft.waxed_weathered_copper_door": "上蠟的風化銅門",
  "block.minecraft.waxed_weathered_copper_golem_statue": "上蠟的風化銅像",
  "block.minecraft.waxed_weathered_copper_grate": "上蠟的風化銅格柵",
  "block.minecraft.waxed_weathered_copper_lantern": "上蠟的風化銅燈籠",
  "block.minecraft.waxed_weathered_copper_trapdoor": "上蠟的風化銅地板門",
  "block.minecraft.waxed_weathered_cut_copper": "上蠟的風化切製銅方塊",
  "block.minecraft.waxed_weathered_cut_copper_slab": "上蠟的風化切製銅半磚",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "上蠟的風化切製銅階梯",
  "block.minecraft.waxed_weathered_lightning_rod": "上蠟的風化避雷針",
  "block.minecraft.weathered_chiseled_copper": "風化的浮雕銅方塊",
  "block.minecraft.weathered_copper": "風化的銅方塊",
  "block.minecraft.weathered_copper_bars": "風化的銅柵欄",
  "block.minecraft.weathered_copper_bulb": "風化的銅燈",
  "block.minecraft.weathered_copper_chain": "風化的銅鏈",
  "block.minecraft.weathered_copper_chest": "風化的銅儲物箱",
  "block.minecraft.weathered_copper_door": "風化的銅門",
  "block.minecraft.weathered_copper_golem_statue": "風化的銅像",
  "block.minecraft.weathered_copper_grate": "風化的銅格柵",
  "block.minecraft.weathered_copper_lantern": "風化的銅燈籠",
  "block.minecraft.weathered_copper_trapdoor": "風化的銅地板門",
  "block.minecraft.weathered_cut_copper": "風化的切製銅方塊",
  "block.minecraft.weathered_cut_copper_slab": "風化的切製銅半磚",
  "block.minecraft.weathered_cut_copper_stairs": "風化的切製銅階梯",
  "block.minecraft.weathered_lightning_rod": "風化的避雷針",
  "block.minecraft.weeping_vines": "垂泣藤",
  "block.minecraft.weeping_vines_plant": "垂泣藤植株",
  "block.minecraft.wet_sponge": "濕海綿",
  "block.minecraft.wheat": "小麥植株",
  "block.minecraft.white_banner": "白色旗幟",
  "block.minecraft.white_bed": "白色床",
  "block.minecraft.white_candle": "白色蠟燭",
  "block.minecraft.white_candle_cake": "插上白色蠟燭的蛋糕",
  "block.minecraft.white_carpet": "白色地毯",
  "block.minecraft.white_concrete": "白色混凝土",
  "block.minecraft.white_concrete_powder": "白色混凝土粉末",
  "block.minecraft.white_glazed_terracotta": "白色釉陶",
  "block.minecraft.white_shulker_box": "白色界伏盒",
  "block.minecraft.white_stained_glass": "白色玻璃",
  "block.minecraft.white_stained_glass_pane": "白色玻璃片",
  "block.minecraft.white_terracotta": "白色陶土",
  "block.minecraft.white_tulip": "白色鬱金香",
  "block.minecraft.white_wool": "白色羊毛",
  "block.minecraft.wildflowers": "野花簇",
  "block.minecraft.wither_rose": "凋零玫瑰",
  "block.minecraft.wither_skeleton_skull": "凋零骷髏頭顱",
  "block.minecraft.wither_skeleton_wall_skull": "牆上的凋零骷髏頭顱",
  "block.minecraft.yellow_banner": "黃色旗幟",
  "block.minecraft.yellow_bed": "黃色床",
  "block.minecraft.yellow_candle": "黃色蠟燭",
  "block.minecraft.yellow_candle_cake": "插上黃色蠟燭的蛋糕",
  "block.minecraft.yellow_carpet": "黃色地毯",
  "block.minecraft.yellow_concrete": "黃色混凝土",
  "block.minecraft.yellow_concrete_powder": "黃色混凝土粉末",
  "block.minecraft.yellow_glazed_terracotta": "黃色釉陶",
  "block.minecraft.yellow_shulker_box": "黃色界伏盒",
  "block.minecraft.yellow_stained_glass": "黃色玻璃",
  "block.minecraft.yellow_stained_glass_pane": "黃色玻璃片",
  "block.minecraft.yellow_terracotta": "黃色陶土",
  "block.minecraft.yellow_wool": "黃色羊毛",
  "block.minecraft.zombie_head": "殭屍頭顱",
  "block.minecraft.zombie_wall_head": "牆上的殭屍頭顱",
  "item.minecraft.acacia_boat": "相思木船",
  "item.minecraft.acacia_chest_boat": "儲物箱相思木船",
  "item.minecraft.allay_spawn_egg": "悅靈生怪蛋",
  "item.minecraft.amethyst_shard": "紫水晶碎片",
  "item.minecraft.angler_pottery_shard": "垂釣陶器碎片",
  "item.minecraft.angler_pottery_sherd": "垂釣陶器碎片",
  "item.minecraft.apple": "蘋果",
  "item.minecraft.archer_pottery_shard": "弓箭陶器碎片",
  "item.minecraft.archer_pottery_sherd": "弓箭陶器碎片",
  "item.minecraft.armadillo_scute": "犰狳鱗甲",
  "item.minecraft.armadillo_spawn_egg": "犰狳生怪蛋",
  "item.minecraft.armor_stand": "盔甲座",
  "item.minecraft.arms_up_pottery_shard": "人形陶器碎片",
  "item.minecraft.arms_up_pottery_sherd": "人形陶器碎片",
  "item.minecraft.arrow": "箭矢",
  "item.minecraft.axolotl_bucket": "六角恐龍桶",
  "item.minecraft.axolotl_spawn_egg": "六角恐龍生怪蛋",
  "item.minecraft.baked_potato": "烤馬鈴薯",
  "item.minecraft.bamboo_chest_raft": "儲物箱竹筏",
  "item.minecraft.bamboo_raft": "竹筏",
  "item.minecraft.bat_spawn_egg": "蝙蝠生怪蛋",
  "item.minecraft.bee_spawn_egg": "蜜蜂生怪蛋",
  "item.minecraft.beef": "生牛肉",
  "item.minecraft.beetroot": "甜菜根",
  "item.minecraft.beetroot_seeds": "甜菜種子",
  "item.minecraft.beetroot_soup": "甜菜湯",
  "item.minecraft.birch_boat": "樺木船",
  "item.minecraft.birch_chest_boat": "儲物箱樺木船",
  "item.minecraft.black_bundle": "黑色束口袋",
  "item.minecraft.black_dye": "黑色染料",
  "item.minecraft.black_harness": "黑色帽鞍",
  "item.minecraft.blade_pottery_shard": "利刃陶器碎片",
  "item.minecraft.blade_pottery_sherd": "利刃陶器碎片",
  "item.minecraft.blaze_powder": "烈焰粉",
  "item.minecraft.blaze_rod": "烈焰桿",
  "item.minecraft.blaze_spawn_egg": "烈焰使者生怪蛋",
  "item.minecraft.blue_bundle": "藍色束口袋",
  "item.minecraft.blue_dye": "藍色染料",
  "item.minecraft.blue_egg": "藍色雞蛋",
  "item.minecraft.blue_harness": "藍色帽鞍",
  "item.minecraft.bogged_spawn_egg": "沼骸生怪蛋",
  "item.minecraft.bolt_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "鑲鉚盔甲紋樣",
  "item.minecraft.bone": "骨頭",
  "item.minecraft.bone_meal": "骨粉",
  "item.minecraft.book": "書",
  "item.minecraft.bordure_indented_banner_pattern": "鋸齒框邊旗幟圖案",
  "item.minecraft.bow": "弓",
  "item.minecraft.bowl": "碗",
  "item.minecraft.bread": "麵包",
  "item.minecraft.breeze_rod": "旋風桿",
  "item.minecraft.breeze_spawn_egg": "旋風使者生怪蛋",
  "item.minecraft.brewer_pottery_shard": "釀造陶器碎片",
  "item.minecraft.brewer_pottery_sherd": "釀造陶器碎片",
  "item.minecraft.brewing_stand": "釀造台",
  "item.minecraft.brick": "紅磚頭",
  "item.minecraft.brown_bundle": "棕色束口袋",
  "item.minecraft.brown_dye": "棕色染料",
  "item.minecraft.brown_egg": "棕色雞蛋",
  "item.minecraft.brown_harness": "棕色帽鞍",
  "item.minecraft.brush": "刷子",
  "item.minecraft.bucket": "鐵桶",
  "item.minecraft.bundle": "束口袋",
  "item.minecraft.bundle.empty": "空",
  "item.minecraft.bundle.empty.description": "可容納一組混合的物品",
  "item.minecraft.bundle.full": "滿",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "烈焰陶器碎片",
  "item.minecraft.burn_pottery_sherd": "烈焰陶器碎片",
  "item.minecraft.camel_husk_spawn_egg": "駱駝屍殼生怪蛋",
  "item.minecraft.camel_spawn_egg": "駱駝生怪蛋",
  "item.minecraft.carrot": "胡蘿蔔",
  "item.minecraft.carrot_on_a_stick": "胡蘿蔔釣竿",
  "item.minecraft.cat_spawn_egg": "貓生怪蛋",
  "item.minecraft.cauldron": "鍋釜",
  "item.minecraft.cave_spider_spawn_egg": "洞穴蜘蛛生怪蛋",
  "item.minecraft.chainmail_boots": "鎖鏈靴子",
  "item.minecraft.chainmail_chestplate": "鎖鏈胸甲",
  "item.minecraft.chainmail_helmet": "鎖鏈頭盔",
  "item.minecraft.chainmail_leggings": "鎖鏈護腿",
  "item.minecraft.charcoal": "木炭",
  "item.minecraft.cherry_boat": "櫻花木船",
  "item.minecraft.cherry_chest_boat": "儲物箱櫻花木船",
  "item.minecraft.chest_minecart": "儲物箱礦車",
  "item.minecraft.chicken": "生雞肉",
  "item.minecraft.chicken_spawn_egg": "雞生怪蛋",
  "item.minecraft.chorus_fruit": "歌萊果",
  "item.minecraft.clay_ball": "黏土球",
  "item.minecraft.clock": "時鐘",
  "item.minecraft.coal": "煤炭",
  "item.minecraft.coast_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.coast_armor_trim_smithing_template.new": "海岸盔甲紋樣",
  "item.minecraft.cocoa_beans": "可可豆",
  "item.minecraft.cod": "生鱈魚",
  "item.minecraft.cod_bucket": "鱈魚桶",
  "item.minecraft.cod_spawn_egg": "鱈魚生怪蛋",
  "item.minecraft.command_block_minecart": "指令方塊礦車",
  "item.minecraft.compass": "羅盤",
  "item.minecraft.cooked_beef": "牛排",
  "item.minecraft.cooked_chicken": "烤雞",
  "item.minecraft.cooked_cod": "烤鱈魚",
  "item.minecraft.cooked_mutton": "烤羊肉",
  "item.minecraft.cooked_porkchop": "烤豬肉",
  "item.minecraft.cooked_rabbit": "烤兔肉",
  "item.minecraft.cooked_salmon": "烤鮭魚",
  "item.minecraft.cookie": "餅乾",
  "item.minecraft.copper_axe": "銅斧",
  "item.minecraft.copper_boots": "銅製靴子",
  "item.minecraft.copper_chestplate": "銅製胸甲",
  "item.minecraft.copper_golem_spawn_egg": "銅魔像生怪蛋",
  "item.minecraft.copper_helmet": "銅製頭盔",
  "item.minecraft.copper_hoe": "銅鋤",
  "item.minecraft.copper_horse_armor": "銅製馬鎧",
  "item.minecraft.copper_ingot": "銅錠",
  "item.minecraft.copper_leggings": "銅製護腿",
  "item.minecraft.copper_nautilus_armor": "銅製鸚鵡螺鎧",
  "item.minecraft.copper_nugget": "銅粒",
  "item.minecraft.copper_pickaxe": "銅鎬",
  "item.minecraft.copper_shovel": "銅鏟",
  "item.minecraft.copper_spear": "銅矛",
  "item.minecraft.copper_sword": "銅劍",
  "item.minecraft.cow_spawn_egg": "牛生怪蛋",
  "item.minecraft.creaking_spawn_egg": "嘎枝生怪蛋",
  "item.minecraft.creeper_banner_pattern": "旗幟圖案",
  "item.minecraft.creeper_banner_pattern.desc": "苦力怕圖紋",
  "item.minecraft.creeper_banner_pattern.new": "苦力怕圖紋旗幟圖案",
  "item.minecraft.creeper_spawn_egg": "苦力怕生怪蛋",
  "item.minecraft.crossbow": "弩",
  "item.minecraft.crossbow.projectile": "投射物：",
  "item.minecraft.crossbow.projectile.multiple": "投射物：%s × %s",
  "item.minecraft.crossbow.projectile.single": "投射物：%s",
  "item.minecraft.cyan_bundle": "青色束口袋",
  "item.minecraft.cyan_dye": "青色染料",
  "item.minecraft.cyan_harness": "青色帽鞍",
  "item.minecraft.danger_pottery_shard": "危機陶器碎片",
  "item.minecraft.danger_pottery_sherd": "危機陶器碎片",
  "item.minecraft.dark_oak_boat": "黑橡木船",
  "item.minecraft.dark_oak_chest_boat": "儲物箱黑橡木船",
  "item.minecraft.debug_stick": "除錯棒",
  "item.minecraft.debug_stick.empty": "%s 沒有屬性",
  "item.minecraft.debug_stick.select": "選擇 \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" to %s",
  "item.minecraft.diamond": "鑽石",
  "item.minecraft.diamond_axe": "鑽石斧",
  "item.minecraft.diamond_boots": "鑽石靴子",
  "item.minecraft.diamond_chestplate": "鑽石胸甲",
  "item.minecraft.diamond_helmet": "鑽石頭盔",
  "item.minecraft.diamond_hoe": "鑽石鋤",
  "item.minecraft.diamond_horse_armor": "鑽石製馬鎧",
  "item.minecraft.diamond_leggings": "鑽石護腿",
  "item.minecraft.diamond_nautilus_armor": "鑽石製鸚鵡螺鎧",
  "item.minecraft.diamond_pickaxe": "鑽石鎬",
  "item.minecraft.diamond_shovel": "鑽石鏟",
  "item.minecraft.diamond_spear": "鑽石矛",
  "item.minecraft.diamond_sword": "鑽石劍",
  "item.minecraft.disc_fragment_5": "唱片碎片",
  "item.minecraft.disc_fragment_5.desc": "唱片 - 5",
  "item.minecraft.dolphin_spawn_egg": "海豚生怪蛋",
  "item.minecraft.donkey_spawn_egg": "驢子生怪蛋",
  "item.minecraft.dragon_breath": "龍之吐息",
  "item.minecraft.dried_kelp": "海帶乾",
  "item.minecraft.drowned_spawn_egg": "沉屍生怪蛋",
  "item.minecraft.dune_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.dune_armor_trim_smithing_template.new": "沙丘盔甲紋樣",
  "item.minecraft.echo_shard": "回聲碎片",
  "item.minecraft.egg": "雞蛋",
  "item.minecraft.elder_guardian_spawn_egg": "遠古深海守衛生怪蛋",
  "item.minecraft.elytra": "鞘翅",
  "item.minecraft.emerald": "綠寶石",
  "item.minecraft.enchanted_book": "附魔書",
  "item.minecraft.enchanted_golden_apple": "附魔金蘋果",
  "item.minecraft.end_crystal": "終界水晶",
  "item.minecraft.ender_dragon_spawn_egg": "終界龍生怪蛋",
  "item.minecraft.ender_eye": "終界之眼",
  "item.minecraft.ender_pearl": "終界珍珠",
  "item.minecraft.enderman_spawn_egg": "終界使者生怪蛋",
  "item.minecraft.endermite_spawn_egg": "終界蟎生怪蛋",
  "item.minecraft.evoker_spawn_egg": "喚魔者生怪蛋",
  "item.minecraft.experience_bottle": "經驗瓶",
  "item.minecraft.explorer_pottery_shard": "探險陶器碎片",
  "item.minecraft.explorer_pottery_sherd": "探險陶器碎片",
  "item.minecraft.eye_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.eye_armor_trim_smithing_template.new": "眼眸盔甲紋樣",
  "item.minecraft.feather": "羽毛",
  "item.minecraft.fermented_spider_eye": "發酵蜘蛛眼",
  "item.minecraft.field_masoned_banner_pattern": "磚牆花紋旗幟圖案",
  "item.minecraft.filled_map": "地圖",
  "item.minecraft.fire_charge": "火焰彈",
  "item.minecraft.firework_rocket": "煙火",
  "item.minecraft.firework_rocket.flight": "飛行時間：",
  "item.minecraft.firework_rocket.multiple_stars": "%s × %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "火藥球",
  "item.minecraft.firework_star.black": "黑色",
  "item.minecraft.firework_star.blue": "藍色",
  "item.minecraft.firework_star.brown": "棕色",
  "item.minecraft.firework_star.custom_color": "自訂",
  "item.minecraft.firework_star.cyan": "青色",
  "item.minecraft.firework_star.fade_to": "淡出",
  "item.minecraft.firework_star.flicker": "閃爍",
  "item.minecraft.firework_star.gray": "灰色",
  "item.minecraft.firework_star.green": "綠色",
  "item.minecraft.firework_star.light_blue": "淺藍色",
  "item.minecraft.firework_star.light_gray": "淺灰色",
  "item.minecraft.firework_star.lime": "淺綠色",
  "item.minecraft.firework_star.magenta": "洋紅色",
  "item.minecraft.firework_star.orange": "橙色",
  "item.minecraft.firework_star.pink": "粉紅色",
  "item.minecraft.firework_star.purple": "紫色",
  "item.minecraft.firework_star.red": "紅色",
  "item.minecraft.firework_star.shape": "未知形狀",
  "item.minecraft.firework_star.shape.burst": "爆裂",
  "item.minecraft.firework_star.shape.creeper": "苦力怕形",
  "item.minecraft.firework_star.shape.large_ball": "大型球狀",
  "item.minecraft.firework_star.shape.small_ball": "小型球狀",
  "item.minecraft.firework_star.shape.star": "星形",
  "item.minecraft.firework_star.trail": "軌跡",
  "item.minecraft.firework_star.white": "白色",
  "item.minecraft.firework_star.yellow": "黃色",
  "item.minecraft.fishing_rod": "釣竿",
  "item.minecraft.flint": "燧石",
  "item.minecraft.flint_and_steel": "打火石",
  "item.minecraft.flow_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.flow_armor_trim_smithing_template.new": "渦流盔甲紋樣",
  "item.minecraft.flow_banner_pattern": "旗幟圖案",
  "item.minecraft.flow_banner_pattern.desc": "渦流",
  "item.minecraft.flow_banner_pattern.new": "渦流旗幟圖案",
  "item.minecraft.flow_pottery_sherd": "渦流陶器碎片",
  "item.minecraft.flower_banner_pattern": "旗幟圖案",
  "item.minecraft.flower_banner_pattern.desc": "花朵圖紋",
  "item.minecraft.flower_banner_pattern.new": "花朵圖紋旗幟圖案",
  "item.minecraft.flower_pot": "花盆",
  "item.minecraft.fox_spawn_egg": "狐狸生怪蛋",
  "item.minecraft.friend_pottery_shard": "摯友陶器碎片",
  "item.minecraft.friend_pottery_sherd": "摯友陶器碎片",
  "item.minecraft.frog_spawn_egg": "青蛙生怪蛋",
  "item.minecraft.furnace_minecart": "熔爐礦車",
  "item.minecraft.ghast_spawn_egg": "地獄幽靈生怪蛋",
  "item.minecraft.ghast_tear": "幽靈之淚",
  "item.minecraft.glass_bottle": "玻璃瓶",
  "item.minecraft.glistering_melon_slice": "鑲金西瓜片",
  "item.minecraft.globe_banner_pattern": "旗幟圖案",
  "item.minecraft.globe_banner_pattern.desc": "地球",
  "item.minecraft.globe_banner_pattern.new": "地球旗幟圖案",
  "item.minecraft.glow_berries": "螢光莓",
  "item.minecraft.glow_ink_sac": "螢光墨囊",
  "item.minecraft.glow_item_frame": "螢光物品展示框",
  "item.minecraft.glow_squid_spawn_egg": "螢光魷魚生怪蛋",
  "item.minecraft.glowstone_dust": "螢石粉",
  "item.minecraft.goat_horn": "山羊角",
  "item.minecraft.goat_spawn_egg": "山羊生怪蛋",
  "item.minecraft.gold_ingot": "金錠",
  "item.minecraft.gold_nugget": "金粒",
  "item.minecraft.golden_apple": "金蘋果",
  "item.minecraft.golden_axe": "金斧",
  "item.minecraft.golden_boots": "黃金靴子",
  "item.minecraft.golden_carrot": "金胡蘿蔔",
  "item.minecraft.golden_chestplate": "黃金胸甲",
  "item.minecraft.golden_helmet": "黃金頭盔",
  "item.minecraft.golden_hoe": "金鋤",
  "item.minecraft.golden_horse_armor": "黃金製馬鎧",
  "item.minecraft.golden_leggings": "黃金護腿",
  "item.minecraft.golden_nautilus_armor": "黃金製鸚鵡螺鎧",
  "item.minecraft.golden_pickaxe": "金鎬",
  "item.minecraft.golden_shovel": "金鏟",
  "item.minecraft.golden_spear": "金矛",
  "item.minecraft.golden_sword": "金劍",
  "item.minecraft.gray_bundle": "灰色束口袋",
  "item.minecraft.gray_dye": "灰色染料",
  "item.minecraft.gray_harness": "灰色帽鞍",
  "item.minecraft.green_bundle": "綠色束口袋",
  "item.minecraft.green_dye": "綠色染料",
  "item.minecraft.green_harness": "綠色帽鞍",
  "item.minecraft.guardian_spawn_egg": "深海守衛生怪蛋",
  "item.minecraft.gunpowder": "火藥",
  "item.minecraft.guster_banner_pattern": "旗幟圖案",
  "item.minecraft.guster_banner_pattern.desc": "狂風",
  "item.minecraft.guster_banner_pattern.new": "狂風旗幟圖案",
  "item.minecraft.guster_pottery_sherd": "狂風陶器碎片",
  "item.minecraft.happy_ghast_spawn_egg": "快樂幽靈生怪蛋",
  "item.minecraft.harness": "帽鞍",
  "item.minecraft.heart_of_the_sea": "海洋之心",
  "item.minecraft.heart_pottery_shard": "愛心陶器碎片",
  "item.minecraft.heart_pottery_sherd": "愛心陶器碎片",
  "item.minecraft.heartbreak_pottery_shard": "心碎陶器碎片",
  "item.minecraft.heartbreak_pottery_sherd": "心碎陶器碎片",
  "item.minecraft.hoglin_spawn_egg": "豬布獸生怪蛋",
  "item.minecraft.honey_bottle": "蜂蜜瓶",
  "item.minecraft.honeycomb": "蜂巢",
  "item.minecraft.hopper_minecart": "漏斗礦車",
  "item.minecraft.horse_spawn_egg": "馬生怪蛋",
  "item.minecraft.host_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.host_armor_trim_smithing_template.new": "主人盔甲紋樣",
  "item.minecraft.howl_pottery_shard": "狼嚎陶器碎片",
  "item.minecraft.howl_pottery_sherd": "狼嚎陶器碎片",
  "item.minecraft.husk_spawn_egg": "屍殼生怪蛋",
  "item.minecraft.ink_sac": "墨囊",
  "item.minecraft.iron_axe": "鐵斧",
  "item.minecraft.iron_boots": "鐵製靴子",
  "item.minecraft.iron_chestplate": "鐵製胸甲",
  "item.minecraft.iron_golem_spawn_egg": "鐵魔像生怪蛋",
  "item.minecraft.iron_helmet": "鐵製頭盔",
  "item.minecraft.iron_hoe": "鐵鋤",
  "item.minecraft.iron_horse_armor": "鐵製馬鎧",
  "item.minecraft.iron_ingot": "鐵錠",
  "item.minecraft.iron_leggings": "鐵製護腿",
  "item.minecraft.iron_nautilus_armor": "鐵製鸚鵡螺鎧",
  "item.minecraft.iron_nugget": "鐵粒",
  "item.minecraft.iron_pickaxe": "鐵鎬",
  "item.minecraft.iron_shovel": "鐵鏟",
  "item.minecraft.iron_spear": "鐵矛",
  "item.minecraft.iron_sword": "鐵劍",
  "item.minecraft.item_frame": "物品展示框",
  "item.minecraft.jungle_boat": "叢林木船",
  "item.minecraft.jungle_chest_boat": "儲物箱叢林木船",
  "item.minecraft.knowledge_book": "知識之書",
  "item.minecraft.lapis_lazuli": "青金石",
  "item.minecraft.lava_bucket": "熔岩桶",
  "item.minecraft.lead": "拴繩",
  "item.minecraft.leather": "皮革",
  "item.minecraft.leather_boots": "皮革靴子",
  "item.minecraft.leather_chestplate": "皮革上衣",
  "item.minecraft.leather_helmet": "皮革帽子",
  "item.minecraft.leather_horse_armor": "皮革製馬鎧",
  "item.minecraft.leather_leggings": "皮革褲子",
  "item.minecraft.light_blue_bundle": "淺藍色束口袋",
  "item.minecraft.light_blue_dye": "淺藍色染料",
  "item.minecraft.light_blue_harness": "淺藍色帽鞍",
  "item.minecraft.light_gray_bundle": "淺灰色束口袋",
  "item.minecraft.light_gray_dye": "淺灰色染料",
  "item.minecraft.light_gray_harness": "淺灰色帽鞍",
  "item.minecraft.lime_bundle": "淺綠色束口袋",
  "item.minecraft.lime_dye": "淺綠色染料",
  "item.minecraft.lime_harness": "淺綠色帽鞍",
  "item.minecraft.lingering_potion": "滯留藥水",
  "item.minecraft.lingering_potion.effect.awkward": "滯留基礎藥水",
  "item.minecraft.lingering_potion.effect.empty": "滯留不可合成的藥水",
  "item.minecraft.lingering_potion.effect.fire_resistance": "滯留抗火藥水",
  "item.minecraft.lingering_potion.effect.harming": "滯留傷害藥水",
  "item.minecraft.lingering_potion.effect.healing": "滯留治療藥水",
  "item.minecraft.lingering_potion.effect.infested": "滯留蛀蝕藥水",
  "item.minecraft.lingering_potion.effect.invisibility": "滯留隱形藥水",
  "item.minecraft.lingering_potion.effect.leaping": "滯留跳躍藥水",
  "item.minecraft.lingering_potion.effect.levitation": "滯留懸浮藥水",
  "item.minecraft.lingering_potion.effect.luck": "滯留幸運藥水",
  "item.minecraft.lingering_potion.effect.mundane": "滯留平凡藥水",
  "item.minecraft.lingering_potion.effect.night_vision": "滯留夜視藥水",
  "item.minecraft.lingering_potion.effect.oozing": "滯留滲漿藥水",
  "item.minecraft.lingering_potion.effect.poison": "滯留劇毒藥水",
  "item.minecraft.lingering_potion.effect.regeneration": "滯留回復藥水",
  "item.minecraft.lingering_potion.effect.slow_falling": "滯留緩降藥水",
  "item.minecraft.lingering_potion.effect.slowness": "滯留緩速藥水",
  "item.minecraft.lingering_potion.effect.strength": "滯留力量藥水",
  "item.minecraft.lingering_potion.effect.swiftness": "滯留迅捷藥水",
  "item.minecraft.lingering_potion.effect.thick": "滯留黏稠藥水",
  "item.minecraft.lingering_potion.effect.turtle_master": "滯留龜仙藥水",
  "item.minecraft.lingering_potion.effect.water": "滯留水瓶",
  "item.minecraft.lingering_potion.effect.water_breathing": "滯留水下呼吸藥水",
  "item.minecraft.lingering_potion.effect.weakness": "滯留虛弱藥水",
  "item.minecraft.lingering_potion.effect.weaving": "滯留結網藥水",
  "item.minecraft.lingering_potion.effect.wind_charged": "滯留蘊風藥水",
  "item.minecraft.llama_spawn_egg": "駱馬生怪蛋",
  "item.minecraft.lodestone_compass": "磁石羅盤",
  "item.minecraft.mace": "重錘",
  "item.minecraft.magenta_bundle": "洋紅色束口袋",
  "item.minecraft.magenta_dye": "洋紅色染料",
  "item.minecraft.magenta_harness": "洋紅色帽鞍",
  "item.minecraft.magma_cream": "岩漿球",
  "item.minecraft.magma_cube_spawn_egg": "岩漿立方怪生怪蛋",
  "item.minecraft.mangrove_boat": "紅樹林木船",
  "item.minecraft.mangrove_chest_boat": "儲物箱紅樹林木船",
  "item.minecraft.map": "空白地圖",
  "item.minecraft.melon_seeds": "西瓜種子",
  "item.minecraft.melon_slice": "西瓜片",
  "item.minecraft.milk_bucket": "鮮奶桶",
  "item.minecraft.minecart": "礦車",
  "item.minecraft.miner_pottery_shard": "礦工陶器碎片",
  "item.minecraft.miner_pottery_sherd": "礦工陶器碎片",
  "item.minecraft.mojang_banner_pattern": "旗幟圖案",
  "item.minecraft.mojang_banner_pattern.desc": "Mojang 圖紋",
  "item.minecraft.mojang_banner_pattern.new": "Mojang 標誌旗幟圖案",
  "item.minecraft.mooshroom_spawn_egg": "哞菇生怪蛋",
  "item.minecraft.mourner_pottery_shard": "悼惜陶器碎片",
  "item.minecraft.mourner_pottery_sherd": "悼惜陶器碎片",
  "item.minecraft.mule_spawn_egg": "騾子生怪蛋",
  "item.minecraft.mushroom_stew": "蘑菇湯",
  "item.minecraft.music_disc_11": "唱片",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "唱片",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "唱片",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "唱片",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "唱片",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "唱片",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "唱片",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "唱片",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator（音樂盒）",
  "item.minecraft.music_disc_far": "唱片",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "唱片",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "唱片",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "唱片",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "唱片",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "唱片",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "唱片",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "唱片",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "唱片",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "唱片",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "唱片",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "唱片",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "唱片",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "生羊肉",
  "item.minecraft.name_tag": "命名牌",
  "item.minecraft.nautilus_shell": "鸚鵡螺殼",
  "item.minecraft.nautilus_spawn_egg": "鸚鵡螺生怪蛋",
  "item.minecraft.nether_brick": "地獄磚頭",
  "item.minecraft.nether_star": "地獄之星",
  "item.minecraft.nether_wart": "地獄疙瘩",
  "item.minecraft.netherite_axe": "獄髓斧",
  "item.minecraft.netherite_boots": "獄髓靴子",
  "item.minecraft.netherite_chestplate": "獄髓胸甲",
  "item.minecraft.netherite_helmet": "獄髓頭盔",
  "item.minecraft.netherite_hoe": "獄髓鋤",
  "item.minecraft.netherite_horse_armor": "獄髓製馬鎧",
  "item.minecraft.netherite_ingot": "獄髓錠",
  "item.minecraft.netherite_leggings": "獄髓護腿",
  "item.minecraft.netherite_nautilus_armor": "獄髓製鸚鵡螺鎧",
  "item.minecraft.netherite_pickaxe": "獄髓鎬",
  "item.minecraft.netherite_scrap": "獄髓碎片",
  "item.minecraft.netherite_shovel": "獄髓鏟",
  "item.minecraft.netherite_spear": "獄髓矛",
  "item.minecraft.netherite_sword": "獄髓劍",
  "item.minecraft.netherite_upgrade_smithing_template": "鍛造模板",
  "item.minecraft.netherite_upgrade_smithing_template.new": "獄髓升級",
  "item.minecraft.oak_boat": "橡木船",
  "item.minecraft.oak_chest_boat": "儲物箱橡木船",
  "item.minecraft.ocelot_spawn_egg": "山貓生怪蛋",
  "item.minecraft.ominous_bottle": "不祥之瓶",
  "item.minecraft.ominous_trial_key": "不祥試煉鑰匙",
  "item.minecraft.orange_bundle": "橙色束口袋",
  "item.minecraft.orange_dye": "橙色染料",
  "item.minecraft.orange_harness": "橙色帽鞍",
  "item.minecraft.painting": "繪畫",
  "item.minecraft.pale_oak_boat": "蒼白橡木船",
  "item.minecraft.pale_oak_chest_boat": "儲物箱蒼白橡木船",
  "item.minecraft.panda_spawn_egg": "貓熊生怪蛋",
  "item.minecraft.paper": "紙",
  "item.minecraft.parched_spawn_egg": "枯骸生怪蛋",
  "item.minecraft.parrot_spawn_egg": "鸚鵡生怪蛋",
  "item.minecraft.phantom_membrane": "夜魅皮膜",
  "item.minecraft.phantom_spawn_egg": "夜魅生怪蛋",
  "item.minecraft.pig_spawn_egg": "豬生怪蛋",
  "item.minecraft.piglin_banner_pattern": "旗幟圖案",
  "item.minecraft.piglin_banner_pattern.desc": "豬鼻",
  "item.minecraft.piglin_banner_pattern.new": "豬鼻旗幟圖案",
  "item.minecraft.piglin_brute_spawn_egg": "豬布林蠻兵生怪蛋",
  "item.minecraft.piglin_spawn_egg": "豬布林生怪蛋",
  "item.minecraft.pillager_spawn_egg": "掠奪者生怪蛋",
  "item.minecraft.pink_bundle": "粉紅色束口袋",
  "item.minecraft.pink_dye": "粉紅色染料",
  "item.minecraft.pink_harness": "粉紅色帽鞍",
  "item.minecraft.pitcher_plant": "瓶子草",
  "item.minecraft.pitcher_pod": "瓶子草豆莢",
  "item.minecraft.plenty_pottery_shard": "富饒陶器碎片",
  "item.minecraft.plenty_pottery_sherd": "富饒陶器碎片",
  "item.minecraft.poisonous_potato": "毒馬鈴薯",
  "item.minecraft.polar_bear_spawn_egg": "北極熊生怪蛋",
  "item.minecraft.popped_chorus_fruit": "爆開的歌萊果",
  "item.minecraft.porkchop": "生豬肉",
  "item.minecraft.potato": "馬鈴薯",
  "item.minecraft.potion": "藥水",
  "item.minecraft.potion.effect.awkward": "基礎藥水",
  "item.minecraft.potion.effect.empty": "不可合成的藥水",
  "item.minecraft.potion.effect.fire_resistance": "抗火藥水",
  "item.minecraft.potion.effect.harming": "傷害藥水",
  "item.minecraft.potion.effect.healing": "治療藥水",
  "item.minecraft.potion.effect.infested": "蛀蝕藥水",
  "item.minecraft.potion.effect.invisibility": "隱形藥水",
  "item.minecraft.potion.effect.leaping": "跳躍藥水",
  "item.minecraft.potion.effect.levitation": "懸浮藥水",
  "item.minecraft.potion.effect.luck": "幸運藥水",
  "item.minecraft.potion.effect.mundane": "平凡藥水",
  "item.minecraft.potion.effect.night_vision": "夜視藥水",
  "item.minecraft.potion.effect.oozing": "滲漿藥水",
  "item.minecraft.potion.effect.poison": "劇毒藥水",
  "item.minecraft.potion.effect.regeneration": "回復藥水",
  "item.minecraft.potion.effect.slow_falling": "緩降藥水",
  "item.minecraft.potion.effect.slowness": "緩速藥水",
  "item.minecraft.potion.effect.strength": "力量藥水",
  "item.minecraft.potion.effect.swiftness": "迅捷藥水",
  "item.minecraft.potion.effect.thick": "黏稠藥水",
  "item.minecraft.potion.effect.turtle_master": "龜仙藥水",
  "item.minecraft.potion.effect.water": "水瓶",
  "item.minecraft.potion.effect.water_breathing": "水下呼吸藥水",
  "item.minecraft.potion.effect.weakness": "虛弱藥水",
  "item.minecraft.potion.effect.weaving": "結網藥水",
  "item.minecraft.potion.effect.wind_charged": "蘊風藥水",
  "item.minecraft.pottery_shard_archer": "弓箭陶器碎片",
  "item.minecraft.pottery_shard_arms_up": "人形陶器碎片",
  "item.minecraft.pottery_shard_prize": "珍寶陶器碎片",
  "item.minecraft.pottery_shard_skull": "頭顱陶器碎片",
  "item.minecraft.powder_snow_bucket": "粉雪桶",
  "item.minecraft.prismarine_crystals": "海磷晶體",
  "item.minecraft.prismarine_shard": "海磷碎片",
  "item.minecraft.prize_pottery_shard": "珍寶陶器碎片",
  "item.minecraft.prize_pottery_sherd": "珍寶陶器碎片",
  "item.minecraft.pufferfish": "河豚",
  "item.minecraft.pufferfish_bucket": "河豚桶",
  "item.minecraft.pufferfish_spawn_egg": "河豚生怪蛋",
  "item.minecraft.pumpkin_pie": "南瓜派",
  "item.minecraft.pumpkin_seeds": "南瓜種子",
  "item.minecraft.purple_bundle": "紫色束口袋",
  "item.minecraft.purple_dye": "紫色染料",
  "item.minecraft.purple_harness": "紫色帽鞍",
  "item.minecraft.quartz": "地獄石英",
  "item.minecraft.rabbit": "生兔肉",
  "item.minecraft.rabbit_foot": "兔子腳",
  "item.minecraft.rabbit_hide": "兔子皮",
  "item.minecraft.rabbit_spawn_egg": "兔子生怪蛋",
  "item.minecraft.rabbit_stew": "兔肉湯",
  "item.minecraft.raiser_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "牧者盔甲紋樣",
  "item.minecraft.ravager_spawn_egg": "劫毀獸生怪蛋",
  "item.minecraft.raw_copper": "銅原礦",
  "item.minecraft.raw_gold": "金原礦",
  "item.minecraft.raw_iron": "鐵原礦",
  "item.minecraft.recovery_compass": "回生羅盤",
  "item.minecraft.red_bundle": "紅色束口袋",
  "item.minecraft.red_dye": "紅色染料",
  "item.minecraft.red_harness": "紅色帽鞍",
  "item.minecraft.redstone": "紅石粉",
  "item.minecraft.resin_brick": "樹脂磚頭",
  "item.minecraft.resin_clump": "樹脂團",
  "item.minecraft.rib_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.rib_armor_trim_smithing_template.new": "肋骨盔甲紋樣",
  "item.minecraft.rotten_flesh": "腐肉",
  "item.minecraft.saddle": "鞍",
  "item.minecraft.salmon": "生鮭魚",
  "item.minecraft.salmon_bucket": "鮭魚桶",
  "item.minecraft.salmon_spawn_egg": "鮭魚生怪蛋",
  "item.minecraft.scrape_pottery_sherd": "刮削陶器碎片",
  "item.minecraft.scute": "鱗甲",
  "item.minecraft.sentry_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "哨兵盔甲紋樣",
  "item.minecraft.shaper_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "工匠盔甲紋樣",
  "item.minecraft.sheaf_pottery_shard": "麥捆陶器碎片",
  "item.minecraft.sheaf_pottery_sherd": "麥捆陶器碎片",
  "item.minecraft.shears": "剪刀",
  "item.minecraft.sheep_spawn_egg": "綿羊生怪蛋",
  "item.minecraft.shelter_pottery_shard": "樹蔭陶器碎片",
  "item.minecraft.shelter_pottery_sherd": "樹蔭陶器碎片",
  "item.minecraft.shield": "盾牌",
  "item.minecraft.shield.black": "黑色盾牌",
  "item.minecraft.shield.blue": "藍色盾牌",
  "item.minecraft.shield.brown": "棕色盾牌",
  "item.minecraft.shield.cyan": "青色盾牌",
  "item.minecraft.shield.gray": "灰色盾牌",
  "item.minecraft.shield.green": "綠色盾牌",
  "item.minecraft.shield.light_blue": "淺藍色盾牌",
  "item.minecraft.shield.light_gray": "淺灰色盾牌",
  "item.minecraft.shield.lime": "淺綠色盾牌",
  "item.minecraft.shield.magenta": "洋紅色盾牌",
  "item.minecraft.shield.orange": "橙色盾牌",
  "item.minecraft.shield.pink": "粉紅色盾牌",
  "item.minecraft.shield.purple": "紫色盾牌",
  "item.minecraft.shield.red": "紅色盾牌",
  "item.minecraft.shield.white": "白色盾牌",
  "item.minecraft.shield.yellow": "黃色盾牌",
  "item.minecraft.shulker_shell": "界伏殼",
  "item.minecraft.shulker_spawn_egg": "界伏蚌生怪蛋",
  "item.minecraft.sign": "告示牌",
  "item.minecraft.silence_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.silence_armor_trim_smithing_template.new": "寂靜盔甲紋樣",
  "item.minecraft.silverfish_spawn_egg": "蠹魚生怪蛋",
  "item.minecraft.skeleton_horse_spawn_egg": "骷髏馬生怪蛋",
  "item.minecraft.skeleton_spawn_egg": "骷髏生怪蛋",
  "item.minecraft.skull_banner_pattern": "旗幟圖案",
  "item.minecraft.skull_banner_pattern.desc": "骷髏圖紋",
  "item.minecraft.skull_banner_pattern.new": "骷髏圖紋旗幟圖案",
  "item.minecraft.skull_pottery_shard": "頭顱陶器碎片",
  "item.minecraft.skull_pottery_sherd": "頭顱陶器碎片",
  "item.minecraft.slime_ball": "史萊姆球",
  "item.minecraft.slime_spawn_egg": "史萊姆生怪蛋",
  "item.minecraft.smithing_template": "鍛造模板",
  "item.minecraft.smithing_template.applies_to": "可套用在：",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "放置錠或晶體",
  "item.minecraft.smithing_template.armor_trim.applies_to": "盔甲",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "放置盔甲",
  "item.minecraft.smithing_template.armor_trim.ingredients": "錠或晶體",
  "item.minecraft.smithing_template.ingredients": "原材料：",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "放置獄髓錠",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "鑽石裝備",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "放置鑽石盔甲、武器或工具",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "獄髓錠",
  "item.minecraft.smithing_template.upgrade": "已有升級：",
  "item.minecraft.sniffer_spawn_egg": "嗅探獸生怪蛋",
  "item.minecraft.snort_pottery_shard": "嗅探陶器碎片",
  "item.minecraft.snort_pottery_sherd": "嗅探陶器碎片",
  "item.minecraft.snout_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.snout_armor_trim_smithing_template.new": "豬鼻盔甲紋樣",
  "item.minecraft.snow_golem_spawn_egg": "雪人生怪蛋",
  "item.minecraft.snowball": "雪球",
  "item.minecraft.spectral_arrow": "追跡之箭",
  "item.minecraft.spider_eye": "蜘蛛眼",
  "item.minecraft.spider_spawn_egg": "蜘蛛生怪蛋",
  "item.minecraft.spire_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.spire_armor_trim_smithing_template.new": "旋塔盔甲紋樣",
  "item.minecraft.splash_potion": "飛濺藥水",
  "item.minecraft.splash_potion.effect.awkward": "飛濺基礎藥水",
  "item.minecraft.splash_potion.effect.empty": "飛濺不可合成的藥水",
  "item.minecraft.splash_potion.effect.fire_resistance": "飛濺抗火藥水",
  "item.minecraft.splash_potion.effect.harming": "飛濺傷害藥水",
  "item.minecraft.splash_potion.effect.healing": "飛濺治療藥水",
  "item.minecraft.splash_potion.effect.infested": "飛濺蛀蝕藥水",
  "item.minecraft.splash_potion.effect.invisibility": "飛濺隱形藥水",
  "item.minecraft.splash_potion.effect.leaping": "飛濺跳躍藥水",
  "item.minecraft.splash_potion.effect.levitation": "飛濺懸浮藥水",
  "item.minecraft.splash_potion.effect.luck": "飛濺幸運藥水",
  "item.minecraft.splash_potion.effect.mundane": "飛濺平凡藥水",
  "item.minecraft.splash_potion.effect.night_vision": "飛濺夜視藥水",
  "item.minecraft.splash_potion.effect.oozing": "飛濺滲漿藥水",
  "item.minecraft.splash_potion.effect.poison": "飛濺劇毒藥水",
  "item.minecraft.splash_potion.effect.regeneration": "飛濺回復藥水",
  "item.minecraft.splash_potion.effect.slow_falling": "飛濺緩降藥水",
  "item.minecraft.splash_potion.effect.slowness": "飛濺緩速藥水",
  "item.minecraft.splash_potion.effect.strength": "飛濺力量藥水",
  "item.minecraft.splash_potion.effect.swiftness": "飛濺迅捷藥水",
  "item.minecraft.splash_potion.effect.thick": "飛濺黏稠藥水",
  "item.minecraft.splash_potion.effect.turtle_master": "飛濺龜仙藥水",
  "item.minecraft.splash_potion.effect.water": "飛濺水瓶",
  "item.minecraft.splash_potion.effect.water_breathing": "飛濺水下呼吸藥水",
  "item.minecraft.splash_potion.effect.weakness": "飛濺虛弱藥水",
  "item.minecraft.splash_potion.effect.weaving": "飛濺結網藥水",
  "item.minecraft.splash_potion.effect.wind_charged": "飛濺蘊風藥水",
  "item.minecraft.spruce_boat": "杉木船",
  "item.minecraft.spruce_chest_boat": "儲物箱杉木船",
  "item.minecraft.spyglass": "望遠鏡",
  "item.minecraft.squid_spawn_egg": "魷魚生怪蛋",
  "item.minecraft.stick": "木棒",
  "item.minecraft.stone_axe": "石斧",
  "item.minecraft.stone_hoe": "石鋤",
  "item.minecraft.stone_pickaxe": "石鎬",
  "item.minecraft.stone_shovel": "石鏟",
  "item.minecraft.stone_spear": "石矛",
  "item.minecraft.stone_sword": "石劍",
  "item.minecraft.stray_spawn_egg": "流髑生怪蛋",
  "item.minecraft.strider_spawn_egg": "熾足獸生怪蛋",
  "item.minecraft.string": "線",
  "item.minecraft.sugar": "糖",
  "item.minecraft.suspicious_stew": "可疑的燉湯",
  "item.minecraft.sweet_berries": "甜莓",
  "item.minecraft.tadpole_bucket": "蝌蚪桶",
  "item.minecraft.tadpole_spawn_egg": "蝌蚪生怪蛋",
  "item.minecraft.tide_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.tide_armor_trim_smithing_template.new": "潮汐盔甲紋樣",
  "item.minecraft.tipped_arrow": "藥水箭",
  "item.minecraft.tipped_arrow.effect.awkward": "藥水箭",
  "item.minecraft.tipped_arrow.effect.empty": "不可合成的藥水箭",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "抗火之箭",
  "item.minecraft.tipped_arrow.effect.harming": "傷害之箭",
  "item.minecraft.tipped_arrow.effect.healing": "治療之箭",
  "item.minecraft.tipped_arrow.effect.infested": "蛀蝕之箭",
  "item.minecraft.tipped_arrow.effect.invisibility": "隱形之箭",
  "item.minecraft.tipped_arrow.effect.leaping": "跳躍之箭",
  "item.minecraft.tipped_arrow.effect.levitation": "懸浮之箭",
  "item.minecraft.tipped_arrow.effect.luck": "幸運之箭",
  "item.minecraft.tipped_arrow.effect.mundane": "藥水箭",
  "item.minecraft.tipped_arrow.effect.night_vision": "夜視之箭",
  "item.minecraft.tipped_arrow.effect.oozing": "滲漿之箭",
  "item.minecraft.tipped_arrow.effect.poison": "劇毒之箭",
  "item.minecraft.tipped_arrow.effect.regeneration": "回復之箭",
  "item.minecraft.tipped_arrow.effect.slow_falling": "緩降之箭",
  "item.minecraft.tipped_arrow.effect.slowness": "緩速之箭",
  "item.minecraft.tipped_arrow.effect.strength": "力量之箭",
  "item.minecraft.tipped_arrow.effect.swiftness": "迅捷之箭",
  "item.minecraft.tipped_arrow.effect.thick": "藥水箭",
  "item.minecraft.tipped_arrow.effect.turtle_master": "龜仙之箭",
  "item.minecraft.tipped_arrow.effect.water": "飛濺之箭",
  "item.minecraft.tipped_arrow.effect.water_breathing": "水下呼吸之箭",
  "item.minecraft.tipped_arrow.effect.weakness": "虛弱之箭",
  "item.minecraft.tipped_arrow.effect.weaving": "結網之箭",
  "item.minecraft.tipped_arrow.effect.wind_charged": "蘊風之箭",
  "item.minecraft.tnt_minecart": "TNT 礦車",
  "item.minecraft.torchflower_seeds": "火把花種子",
  "item.minecraft.totem_of_undying": "不死圖騰",
  "item.minecraft.trader_llama_spawn_egg": "商駝生怪蛋",
  "item.minecraft.trial_key": "試煉鑰匙",
  "item.minecraft.trident": "三叉戟",
  "item.minecraft.tropical_fish": "熱帶魚",
  "item.minecraft.tropical_fish_bucket": "熱帶魚桶",
  "item.minecraft.tropical_fish_spawn_egg": "熱帶魚生怪蛋",
  "item.minecraft.turtle_helmet": "海龜殼",
  "item.minecraft.turtle_scute": "海龜鱗甲",
  "item.minecraft.turtle_spawn_egg": "海龜生怪蛋",
  "item.minecraft.vex_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.vex_armor_trim_smithing_template.new": "惱鬼盔甲紋樣",
  "item.minecraft.vex_spawn_egg": "惱鬼生怪蛋",
  "item.minecraft.villager_spawn_egg": "村民生怪蛋",
  "item.minecraft.vindicator_spawn_egg": "衛道士生怪蛋",
  "item.minecraft.wandering_trader_spawn_egg": "流浪商人生怪蛋",
  "item.minecraft.ward_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.ward_armor_trim_smithing_template.new": "伏守盔甲紋樣",
  "item.minecraft.warden_spawn_egg": "伏守者生怪蛋",
  "item.minecraft.warped_fungus_on_a_stick": "扭曲蕈菇釣竿",
  "item.minecraft.water_bucket": "水桶",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "嚮導盔甲紋樣",
  "item.minecraft.wheat": "小麥",
  "item.minecraft.wheat_seeds": "小麥種子",
  "item.minecraft.white_bundle": "白色束口袋",
  "item.minecraft.white_dye": "白色染料",
  "item.minecraft.white_harness": "白色帽鞍",
  "item.minecraft.wild_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.wild_armor_trim_smithing_template.new": "荒野盔甲紋樣",
  "item.minecraft.wind_charge": "風彈",
  "item.minecraft.witch_spawn_egg": "女巫生怪蛋",
  "item.minecraft.wither_skeleton_spawn_egg": "凋零骷髏生怪蛋",
  "item.minecraft.wither_spawn_egg": "凋零怪生怪蛋",
  "item.minecraft.wolf_armor": "狼鎧",
  "item.minecraft.wolf_spawn_egg": "狼生怪蛋",
  "item.minecraft.wooden_axe": "木斧",
  "item.minecraft.wooden_hoe": "木鋤",
  "item.minecraft.wooden_pickaxe": "木鎬",
  "item.minecraft.wooden_shovel": "木鏟",
  "item.minecraft.wooden_spear": "木矛",
  "item.minecraft.wooden_sword": "木劍",
  "item.minecraft.writable_book": "書和羽毛筆",
  "item.minecraft.written_book": "完成的書",
  "item.minecraft.yellow_bundle": "黃色束口袋",
  "item.minecraft.yellow_dye": "黃色染料",
  "item.minecraft.yellow_harness": "黃色帽鞍",
  "item.minecraft.zoglin_spawn_egg": "豬屍獸生怪蛋",
  "item.minecraft.zombie_horse_spawn_egg": "殭屍馬生怪蛋",
  "item.minecraft.zombie_nautilus_spawn_egg": "殭屍鸚鵡螺生怪蛋",
  "item.minecraft.zombie_spawn_egg": "殭屍生怪蛋",
  "item.minecraft.zombie_villager_spawn_egg": "殭屍村民生怪蛋",
  "item.minecraft.zombified_piglin_spawn_egg": "殭屍化豬布林生怪蛋"
}
export const zh_tw = items; 
